const locale = {
  DUPLICATE_OF: 'نسخة مكررة من',
  DUPLICATED_BY: 'تم تكراره بواسطة',
  RELATED_TO: 'ذات صلة ب',
  SPLIT_TO: 'انقسام إلى',
  SPLIT_FROM: 'انقسام من',
  BLOCKED_BY: 'تم حظره بواسطة',
  BLOCKS: 'كتل',
  MORE_THAN: 'أكبر من',
  LESS_THAN: 'أقل من',
  OPEN: 'يفتح',
  IN_PROGRESS: 'في تَقَدم',
  ON_HOLD: 'قيد الانتظار',
  COMPLETE: 'مكتمل',
  fetch_more: 'جلب المزيد',
  'home.built': 'تم تصميمه لتسهيل إدارة الصيانة',
  home_description:
    'عندما تكون السبورة البيضاء والملاحظات اللاصقة فوضوية، وتحتاج إلى برنامج CMMS سهل الاستخدام بما يكفي لفريقك - جرب {{shortBrandName}}',
  try_grash: 'جرب أطلس',
  login: 'تسجيل الدخول',
  start_trial: 'ابدأ تجربة مجانية',
  'home.what': 'ماذا',
  'home.you_will_have': 'سيكون لديك',
  'home.you_will_have_description':
    'أنشئ سير عمل فعّالاً وموثوقاً يُمكّنك من التحكم في الصيانة. أنشئ أوامر العمل، وعيّنها، وتتبّعها. تحكّم بالمخزون. واحصل على تقارير آلية موثوقة تُحسّن الرؤية وتُعزّز المساءلة.',
  key_features: 'الميزات الرئيسية',
  key_features_description:
    'بعض الميزات التي تجعل {{shortBrandName}} واحدًا من أفضل أنظمة CMMS المتوفرة اليوم',
  contribute: 'يساهم',
  work_orders: 'أوامر العمل',
  request_system: 'نظام طلب العمل',
  mobile_app: 'تطبيق الجوال',
  asset_management: 'إدارة الأصول',
  preventive_maintenance: 'الصيانة الوقائية',
  parts_inventory: 'مخزون قطع الغيار',
  custom_dashboards: 'لوحات معلومات مخصصة',
  'work-orders.title': 'إدارة أوامر العمل الخاصة بك مثل الرئيس',
  'work-orders.description.short': 'عرض وإدارة جميع مهامك',
  'work-orders.descriptions.0':
    'هل سئمت من أكوام الأوراق وطلبات العمل المفقودة؟ كل هذه العناصر المفقودة تؤثر بشكل مباشر على أرباحك وسمعتك.',
  'work-orders.descriptions.1':
    'باستخدام {{shortBrandName}}، يمكنك تنظيم جميع أوامر العمل ومديري المشاريع والمهام الأخرى بسهولة وسرعة في جميع أنحاء فريقك في قاعدة بيانات مركزية يمكن الوصول إليها من أي مكان وعلى أي جهاز.',
  'work-orders.checks.0':
    'عرض جميع مهامك بما في ذلك أوامر العمل، ورسائل المديرين، وطلبات العمل',
  'work-orders.checks.1':
    'قم بتعيين أولوية المهمة حتى يتم إنجاز العمل الصحيح أولاً.',
  'work-orders.checks.2': 'عرض تقويم للمهام الحالية والمقبلة.',
  'work-orders.checks.3':
    'اعرض مهام العمل مع المعلومات الهامة مثل معلومات الأصول وتاريخ الاستحقاق والأولوية والمزيد.',
  'work-orders.checks.4':
    'عرض مؤشرات الأداء الرئيسية الهامة مثل العمل المنجز فعليًا والوقت المستغرق والعمل المخطط له مقابل العمل غير المخطط له.',
  'work-requests.title': 'نظام طلب عمل متنقل مبسط',
  'work-requests.descriptions.0':
    'هل سئمت من استخدام نظام الهاتف والبريد الإلكتروني القديم الذي يؤدي إلى فقدان التذاكر والمقاطعات اليومية المستمرة وتكرار العمل؟',
  'work-requests.descriptions.1':
    'يتيح حل إدارة الصيانة من {{shortBrandName}} لأي شخص تفوضه إرسال مشكلة إلى قسم الصيانة الخاص بك عن طريق مسح رمز الاستجابة السريعة (الرمز الشريطي) أو زيارة عنوان URL وكتابة طلبه من خلال أجهزته المحمولة.',
  'work-requests.checks.0': 'لا تفقد عملك مرة أخرى.',
  'work-requests.checks.1':
    'تقليل الوقت المستغرق في التعامل مع طلبات العمل بنسبة تصل إلى 34%.',
  'work-requests.checks.2':
    'تقليل وقت التواصل مع مقدمي الطلبات بنسبة تصل إلى 41% (المكالمات، رسائل البريد الإلكتروني، الرسائل النصية).',
  'mobile-app.title':
    'تطبيق CMMS للأجهزة المحمولة الذي يعزز فريق الصيانة الخاص بك',
  'mobile-app.descriptions.0':
    'من خلال استخدام تطبيقاتنا المحمولة بنظامي التشغيل Android و IOS، يحظى عملاؤنا بفرصة أفضل للتنظيم والتواصل والمساءلة والإنتاجية بنسبة تصل إلى 30% في جميع أنحاء فريق الصيانة الخاص بهم.',
  'mobile-app.descriptions.1':
    'يمكن لأي شخص في فريق الصيانة الخاص بك من خلال جهازه المحمول القيام بما يلي:',
  'mobile-app.checks.0': 'عرض أوامر العمل والمشاريع المخصصة لهم.',
  'mobile-app.checks.1': 'تسجيل أوامر العمل الخاصة بهم في أقل من 60 ثانية',
  'mobile-app.checks.2':
    'احصل على اتصالات فورية عبر الإشعارات الفورية والبريد الإلكتروني.',
  'mobile-app.checks.3': 'ابدأ أوامر العمل الجديدة أثناء تواجدك في الميدان.',
  'mobile-app.checks.4': 'الرد على المشكلات وتسجيلها أثناء العمل على حلها',
  'mobile-app.checks.5': 'ابحث عن معلومات الأصول الهامة أثناء تشخيص المشكلة.',
  'eam.title': 'إدارة أصول المؤسسة',
  'eam.description.short': 'تعرف على أصولك',
  'eam.descriptions.0':
    'هل تشعر بالإحباط من محاولة تنظيم الفوضى العارمة لمعدات الشركة، وتتساءل عما إذا كانت المعدات قد تم الاعتناء بها بشكل صحيح، ولا تعرف تكلفة صيانتها وجميع الصداع الآخر الذي يأتي مع إدارة الأصول؟',
  'eam.descriptions.1':
    'يمكن استخدام وحدة إدارة الأصول المؤسسية من {{brandName}} لأي عدد يتراوح بين 10 إلى 1,000,000 من الأصول، مما يسمح لك بتتبع ما تريده بالضبط، بالطريقة التي تريدها، في هيكل شجرة سهل الاستخدام وقابل للبحث.',
  'eam.checks.0': 'تعرف على صحة أصولك في كل نقطة زمنية وما تكلفك',
  'eam.checks.1': 'عرض سجلات الصيانة الكاملة والمفصلة.',
  'eam.checks.2': 'تتبع فقط ما تريده مع حقول مخصصة غير محدودة',
  'eam.checks.3': 'قم بتنظيم أصولك في تسلسل هرمي واضح من الوالد إلى الطفل',
  'eam.checks.4':
    'ابحث عن المعلومات بسرعة وسهولة باستخدام رموز الاستجابة السريعة (الرموز الشريطية)',
  'eam.checks.5':
    'احصل على بيانات الأصول في الوقت الفعلي باستخدام اتصال المستشعر.',
  'pm.title': 'برنامج صيانة وقائية فعال',
  'pm.descriptions.0':
    'توقف عن إهدار ساعات ثمينة في توزيع قوائم التحقق من إدارة المشروع يدويًا ومتابعة فريقك للتأكد من إنجاز العمل.',
  'pm.descriptions.1':
    'يتيح لك {{shortBrandName}} أتمتة جدولة الصيانة الوقائية بسهولة بحيث يتم تسليم العمل المناسب تلقائيًا في الوقت المناسب للفني المناسب للأصل المناسب.',
  'pm.checks.0':
    'أتمتة جدولة الصيانة الوقائية لتكون يومية أو أسبوعية أو شهرية أو سنوية أو بناءً على الأحداث أو قراءات العداد.',
  'pm.checks.1':
    'إشعارات تلقائية بالدفع والبريد الإلكتروني عند إنشاء رسالة خاصة أو استحقاقها.',
  'pm.checks.2':
    'يتيح لك تقويمنا سهل الاستخدام عرض جميع الأعمال المفتوحة وجداول أعمال الصيانة الوقائية القادمة.',
  'pm.checks.3': 'اسحب وأفلِت لتغيير تاريخ الاستحقاق.',
  'pm.checks.4':
    'عند اكتمال الصيانة الوقائية، يتم تسجيل العمل تلقائيًا في سجل صيانة الأصول.',
  'pm.checks.5':
    'يتطلب القليل من التدريب أو لا يتطلب أي تدريب على الإطلاق للاستخدام.',
  'part.title': 'احصل على التحكم في مخزون قطع الغيار الخاص بك',
  'part.description.short': 'اعرف متى ستنفد أجزائك',
  'part.descriptions.0':
    'لست متأكدًا من مخزون قطع الغيار لديك أو مكان استخدامها؟ لا تعرف متى ستنفد قطع الغيار لديك أو ما إذا كان فنيوك سيملكون القطع اللازمة لأداء عملهم؟',
  'part.descriptions.1':
    'لقد قمنا بتصميم نظام إدارة أجزاء {{shortBrandName}} لحل هذه المشكلات وأكثر:',
  'part.checks.0':
    'احصل على إشعارات فورية عبر البريد الإلكتروني والدفع عند انخفاض كمية أي قطعة. حافظ على العدد المناسب من القطع في المخزون من خلال تلقي إشعارات فورية وتلقائية عبر البريد الإلكتروني والدفع عند انخفاض كمية أي قطعة عن الحد الأقصى المُحدد.',
  'part.checks.1':
    'يستطيع الفنيون معرفة ما إذا كانت القطعة متوفرة في المخزون فورًا من خلال أمر العمل. إذا لم تكن القطعة متوفرة، يمكنك بسهولة التحقق من توفرها في مواقع أخرى.',
  'part.checks.2':
    'تتبع تلقائي لاستخدام قطع الغيار. عند استخدام قطع غيار في أوامر العمل أو مديري المشاريع، سيتم تحديث المخزون تلقائيًا ليعكس القطع المستخدمة.',
  'part.checks.3':
    'اعرف استخدامات القطع. اطلع على سجل القطع لمعرفة أماكن استخدامها ومن يستخدمها.',
  'part.checks.4': 'تخلّص من الأجزاء غير المستخدمة. اعرف متى تصبح قطعة قديمة.',
  'part.checks.5': 'تقارير فورية. تعرف على القطع المستخدمة وأين تُكلفك.',
  'part.checks.6':
    'حسّن مستويات المخزون. اطّلع فورًا على توقعات الطلب على قطعة ما لمعرفة عدد القطع التي قد تُستخدم خلال العام المقبل.',
  'part.checks.7':
    'البحث عن الباركود. سهّل تتبع مخزونك والوصول إليه باستخدام رموز الاستجابة السريعة المخصصة.',
  'dashboard.title': 'بياناتك، طريقتك مع لوحات المعلومات المخصصة',
  'dashboard.descriptions.0':
    'لنواجه الأمر، الخطوة الأولى لتحسين عملياتك هي معرفة الجيد والسيئ والقبيح.',
  'dashboard.descriptions.1':
    'باستخدام لوحات معلومات {{shortBrandName}} المخصصة، يمكنك أخيرًا البدء في فهم "الثقب الأسود الشرير للصيانة" والبدء في وضع الخطط المدعومة بالبيانات موضع التنفيذ، مما يؤدي إلى تقليل تكاليف العمالة وتقليل وقت التوقف عن العمل والمزيد.',
  'dashboard.descriptions.2':
    'باستخدام لوحات معلومات {{shortBrandName}} المخصصة، ستتمكن من...',
  'dashboard.checks.0': 'اعرف أين يتم إنفاق أموالك ولماذا',
  'dashboard.checks.1': 'تعرف على الأصول الأكثر تكلفة ولماذا',
  'dashboard.checks.2': 'قم بإنشاء مؤشرات الأداء الرئيسية المخصصة لك.',
  'dashboard.checks.3':
    'عرض التقارير التي يتم إنشاؤها وتحديثها تلقائيًا استنادًا إلى مقياسك',
  'dashboard.checks.4':
    'عرض التقارير التي يمكن مشاركتها بسهولة عبر جداول بيانات Excel أو ملفات PDF أو داخل {{shortBrandName}}',
  'dashboard.checks.5': 'و أكثر من ذلك بكثير...',
  'home.smarter': 'أذكى',
  'home.work': 'عمل',
  'home.smarter_description':
    'يجعل {{shortBrandName}} من السهل بشكل لا يصدق على الفنيين العمل بكفاءة من خلال منحهم إمكانية الوصول إلى الأدوات والبيانات التي يحتاجون إليها لإنجاز العمل - كل ذلك من راحة أيديهم.',
  leading_maintenance: 'الريادة في الطريق نحو مستقبل أفضل للصيانة والموثوقية',
  premium_included: 'الميزات المتميزة المضمنة',
  no_credit_card: 'لا حاجة لبطاقة ائتمان',
  perfect_tool: 'الأداة المثالية لفرق الصيانة',
  start_trial_today: 'ابدأ تجربتك المجانية اليوم',
  create_account: 'إنشاء حساب',
  signup_description: 'قم بملء الحقول أدناه للتسجيل للحصول على حساب.',
  account_already: 'هل لديك حساب بالفعل؟',
  signin_here: 'سجل الدخول هنا',
  invalid_email:
    'يجب أن يكون البريد الإلكتروني المقدم عنوان بريد إلكتروني صالحًا',
  required_email: 'حقل البريد الإلكتروني مطلوب',
  required_firstName: 'حقل الاسم الأول مطلوب',
  required_lastName: 'حقل الاسم الأخير مطلوب',
  required_company: 'حقل اسم الشركة مطلوب',
  required_employeesCount: 'يرجى تقديم عدد الموظفين',
  invalid_phone: 'رقم الهاتف غير صالح',
  required_password: 'حقل كلمة المرور مطلوب',
  required_terms: 'يجب عليك الموافقة على شروطنا وأحكامنا',
  verify_email: 'يرجى التحقق من بريدك الإلكتروني لتفعيل حسابك',
  registration_error: 'لم ينجح التسجيل',
  first_name: 'الاسم الأول',
  last_name: 'اسم العائلة',
  email: 'عنوان البريد الإلكتروني',
  phone: 'هاتف',
  password: 'كلمة المرور',
  companyName: 'اسم الشركة',
  employeesCount: 'عدد الموظفين',
  i_accept: 'انا اقبل',
  terms_conditions: 'الشروط والأحكام',
  create_your_account: 'إنشاء حسابك',
  register: 'يسجل',
  login_description: 'قم بملء الحقول أدناه لتسجيل الدخول إلى حسابك.',
  no_account_yet: 'ليس لديك حساب حتى الآن؟',
  signup_here: 'سجل هنا',
  wrong_credentials: 'تم تقديم بيانات اعتماد خاطئة',
  lost_password: 'فقدت كلمة المرور ؟',
  link_wo: 'ربط أوامر العمل',
  link_wo_description: 'إنشاء علاقات بين أوامر العمل',
  required_relationType: 'الرجاء تحديد نوع العلاقة.',
  required_wo: 'حقل أمر العمل مطلوب.',
  this_wo: 'هذا أمر العمل',
  the_wo: 'أمر العمل',
  link: 'وصلة',
  cost_description: 'وصف التكلفة',
  assigned_to: 'مُخصص لـ',
  category: 'فئة',
  date: 'تاريخ',
  cost: 'يكلف',
  include_cost: 'قم بتضمين هذه التكلفة في التكلفة الإجمالية',
  include_cost_description:
    'سيؤدي هذا إلى إضافة التكلفة إلى التكلفة الإجمالية التي تم إنفاقها على أمر العمل',
  required_cost_description: 'وصف التكلفة مطلوب',
  required_cost: 'التكلفة مطلوبة',
  add_cost: 'إضافة تكلفة إضافية',
  add_cost_description: 'املأ الحقول أدناه لإنشاء وإضافة تكلفة إضافية',
  add: 'يضيف',
  hourly_rate: 'السعر بالساعة',
  include_time: 'قم بتضمين هذا الوقت في إجمالي الوقت',
  include_time_description:
    'سيؤدي هذا إلى إضافة المدة إلى إجمالي الوقت المستغرق في أمر العمل',
  work_started_at: 'بدأ العمل في',
  duration: 'مدة',
  hours: 'ساعات',
  minutes: 'دقائق',
  required_hours: 'حقل الساعات مطلوب',
  required_minutes: 'حقل الدقائق مطلوب',
  add_time: 'إضافة الوقت',
  add_time_description: 'املأ الحقول أدناه لإنشاء الوقت وإضافته',
  feedback: 'تعليق',
  feedback_description: 'أعط تعليقك',
  required_feedback: 'مطلوب ردود الفعل',
  signature: 'إمضاء',
  required_signature: 'الصورة مطلوبة',
  close_wo: 'إغلاق أمر العمل',
  close: 'يغلق',
  task_update_success: 'تم تحديث المهمة بنجاح',
  task_update_failure: 'لم يتم تحديث المهمة',
  notes_save_success: 'تم حفظ الملاحظات بنجاح',
  images_add_task_success: 'تمت إضافة الصور إلى المهمة',
  images_add_task_failure: 'لقد حدث خطأ ما',
  images: 'الصور',
  required_images: 'يرجى تحميل صورة على الأقل',
  add_images: 'إضافة الصور',
  tasks: 'المهام',
  wo_archive_success: 'تم أرشفة أمر العمل',
  wo_archive_failure: 'لم يتم أرشفة أمر العمل',
  wo_archive_confirm: 'هل أنت متأكد أنك تريد أرشفة أمر العمل هذا؟',
  quantity_change_success: 'تم تغيير الكمية بنجاح',
  quantity_change_failure: 'لم يتم تغيير الكمية',
  details: 'تفاصيل',
  updates: 'التحديثات',
  id: 'بطاقة تعريف',
  due_date: 'تاريخان',
  location: 'موقع',
  asset: 'أصل',
  team: 'فريق',
  created_at: 'تاريخ الإنشاء',
  list_view: 'عرض القائمة',
  calendar_view: 'عرض التقويم',
  column_view: 'عرض العمود',
  wo_create_success: 'تم إنشاء أمر العمل بنجاح',
  wo_create_failure: 'لم يتم إنشاء أمر العمل',
  changes_saved_success: 'تم حفظ التغييرات',
  wo_update_failure: 'لم يتمكن من تعديل أمر العمل',
  wo_delete_success: 'تم حذف أمر العمل بنجاح',
  wo_delete_failure: 'لم يتم حذف أمر العمل',
  status: 'حالة',
  title: 'عنوان',
  priority: 'أولوية',
  description: 'وصف',
  worker: 'عامل',
  location_name: 'اسم الموقع',
  location_address: 'عنوان الموقع',
  asset_name: 'اسم الأصل',
  days_since_creation: 'أيام منذ الخلق',
  files: 'الملفات',
  requested_by: 'تم الطلب بواسطة',
  completed_on: 'تم الانتهاء منه في',
  updated_at: 'تم التحديث في',
  work_order: 'أمر العمل',
  timer_running: 'تشغيل المؤقت',
  run_timer: 'تشغيل المؤقت',
  approved_by: 'تمت الموافقة عليه من قبل',
  created_by: 'تم الإنشاء بواسطة',
  completed_by: 'تم الانتهاء بواسطة',
  time: 'وقت',
  save: 'يحفظ',
  customers: 'المقاولون',
  no_labor:
    'لم تتم إضافة تكاليف العمالة بعد. ستظهر هنا عندما يُسجّل المستخدم وقته ويُخزّن أجره بالساعة في أطلس.',
  not_assigned: 'غير مخصص',
  no_additional_cost: 'لم تتم إضافة أي تكاليف إضافية حتى الآن',
  parts: 'أجزاء',
  links: 'الروابط',
  confirm_delete_file_wo:
    'هل أنت متأكد أنك تريد إزالة هذا الملف من أمر العمل هذا؟',
  archive: 'أرشيف',
  labors: 'أعمال',
  add_additional_cost: 'إضافة تكلفة إضافية',
  additional_costs: 'تكاليف إضافية',
  add_parts: 'إضافة أجزاء',
  'wo.title_description': 'أدخل عنوان أمر العمل',
  image: 'صورة',
  estimated_duration: 'المدة المقدرة بالساعات',
  primary_worker: 'عامل أساسي',
  additional_workers: 'عمال إضافيون',
  select_team: 'اختر الفريق',
  select_location: 'حدد الموقع',
  select_asset: 'حدد الأصول',
  select_tasks: 'تحديد المهام',
  select_pm: 'Select Preventive Maintenance routine',
  requires_signature: 'يتطلب التوقيع',
  required_wo_title: 'عنوان أمر العمل مطلوب',
  add_wo: 'إضافة أمر عمل',
  add_wo_description: 'املأ الحقول أدناه لإنشاء وإضافة أمر عمل جديد',
  edit_wo: 'تعديل أمر العمل',
  edit_wo_description: 'إملأ الحقول أدناه لتحديث أمر العمل',
  'noRows.wo.message':
    'أوامر العمل هي مهام أو وظائف يمكن جدولتها أو تعيينها لشخص ما',
  'noRows.wo.action': 'اضغط على زر "+" لإنشاء أمر عمل',
  to_delete: 'يمسح',
  confirm_delete_wo: 'هل أنت متأكد أنك تريد حذف أمر العمل هذا؟',
  no_access_wo:
    'ليس لديك حق الوصول إلى أوامر العمل. يُرجى التواصل مع مسؤول النظام إذا كان لديك حق الوصول.',
  cancel: 'يلغي',
  select_parts: 'اختر الأجزاء',
  sets_of_parts: 'مجموعات من الأجزاء',
  paused: 'متوقف مؤقتًا',
  trigger_details: 'تفاصيل المشغل',
  starts_on: 'يبدأ في',
  ends_on: 'ينتهي في',
  frequency: 'تكرار',
  every_frequency_days: 'كل {{تردد}} يوم',
  wo_details: 'تفاصيل أمر العمل',
  confirm_delete_file: 'هل أنت متأكد أنك تريد إزالة هذا الملف؟',
  wo_schedule_success: 'تم جدولة أمر العمل بنجاح',
  wo_schedule_failure: 'لم يتم جدولة أمر العمل',
  wo_trigger_edit_failure: 'لم يتمكن من تحرير مشغل أمر العمل',
  wo_trigger_delete_success: 'تم حذف مشغل أمر العمل بنجاح',
  wo_trigger_delete_failure: 'لم يتم حذف مُشغل أمر العمل',
  name: 'اسم',
  wo_title: 'عنوان أمر العمل',
  next_wo: 'أمر العمل التالي',
  trigger_name: 'اسم المشغل',
  enter_trigger_name: 'أدخل اسم المشغل',
  frequency_description: 'التردد بالأيام',
  wo_configuration: 'تكوين أمر العمل',
  required_trigger_name: 'اسم المشغل مطلوب',
  required_frequency: 'تردد الزناد مطلوب',
  invalid_frequency: 'يجب أن يكون التردد أعلى من 0',
  schedule_wo: 'جدولة أمر العمل',
  schedule_wo_description: 'املأ الحقول أدناه لجدولة أمر العمل',
  edit_wo_trigger: 'تعديل مشغل أمر العمل',
  edit_wo_trigger_description: 'املأ الحقول أدناه لتحرير مشغل أمر العمل',
  create_trigger: 'إنشاء مشغل',
  'noRows.pm.message': 'جدولة أوامر العمل باستخدام المشغلات المخصصة',
  'noRows.pm.action': 'اضغط على زر "+" لإنشاء مشغل',
  confirm_delete_pm: 'هل أنت متأكد أنك تريد حذف مشغل أمر العمل هذا؟',
  no_access_pm:
    'ليس لديك حق الوصول إلى قسم الصيانة الوقائية. يُرجى التواصل مع مسؤول النظام إذا كان لديك حق الوصول.',
  enter_wo_title: 'أدخل عنوان أمر العمل',
  status_report: 'تقرير الحالة',
  wo_analysis: 'تحليل أوامر العمل',
  wo_aging: 'تقادم أوامر العمل',
  time_and_cost: 'الوقت والتكلفة',
  assets: 'أصول',
  reliability_dashboard: 'لوحة معلومات الموثوقية',
  total_maintenance_cost: 'إجمالي تكلفة الصيانة',
  useful_life: 'العمر الإنتاجي',
  requests: 'الطلبات',
  locations: 'المواقع',
  parts_and_inventory: 'قطع الغيار/المخزون',
  purchase_orders: 'طلبات الشراء',
  meters: 'أمتار',
  people_teams: 'الأشخاص والفرق',
  people: 'الناس',
  teams: 'الفرق',
  vendors_customers: 'البائعين والمقاولين',
  vendors: 'البائعين',
  categories: 'فئات',
  settings: 'إعدادات',
  cancelled: 'تم الإلغاء',
  reject: 'يرفض',
  approve: 'يعتمد',
  request_create_success: 'تم طلب أمر العمل بنجاح',
  request_create_failure: 'لم يتم إنشاء طلب العمل',
  request_edit_failure: 'لم يتم تعديل الطلب',
  request_delete_success: 'تم حذف الطلب بنجاح',
  request_delete_failure: 'لم يتم حذف الطلب',
  rejected: 'مرفوض',
  approved: 'موافقة',
  pending: 'قيد الانتظار',
  required_request_name: 'عنوان الطلب مطلوب',
  required_field: 'هذه الخانة مطلوبه',
  add_request: 'إضافة طلب',
  add_request_description: 'املأ الحقول أدناه لإنشاء طلب جديد وإضافته',
  edit_request: 'طلب تعديل',
  edit_request_description: 'إملأ الحقول أدناه لتحرير الطلب',
  'noRows.request.message': 'إدارة طلبات العمل الخاصة بك',
  'noRows.request.action': 'اضغط على زر "+" لإنشاء طلب عمل',
  confirm_delete_request: 'هل أنت متأكد أنك تريد حذف هذا الطلب؟',
  request: 'طلب',
  request_details: 'تفاصيل الطلب',
  none_priority: 'لا أحد',
  low_priority: 'قليل',
  medium_priority: 'واسطة',
  high_priority: 'عالي',
  downtimes: 'أوقات التوقف',
  confirm_delete_file_asset:
    'هل أنت متأكد أنك تريد إزالة هذا الملف من هذا الأصل؟',
  actions: 'الإجراءات',
  show: 'يعرض',
  model: 'نموذج',
  serial_number: 'رقم سري',
  operational: 'التشغيلية',
  down: 'تحت',
  area: 'منطقة',
  barcode: 'الباركود',
  placed_in_service: 'تم وضعه في الخدمة',
  warranty_expiration: 'انتهاء صلاحية الضمان',
  asset_information: 'معلومات الأصول',
  more_informations: 'مزيد من المعلومات',
  confirm_delete_asset_downtime: 'هل أنت متأكد أنك تريد إزالة هذا التوقف؟',
  create_downtime_success: 'تمت إضافة وقت التوقف بنجاح',
  create_downtime_failure: 'لم يتمكن من إضافة وقت التوقف',
  edit_downtime_success: 'تم تعديل وقت التوقف بنجاح',
  started_on: 'بدأت في',
  required_startsOn: 'تاريخ البدء مطلوب',
  reading_create_success: 'تمت إضافة القراءة بنجاح',
  reading_create_failure: 'لم يتم إضافة القراءة',
  reading: 'قراءة',
  added_by: 'تمت الإضافة بواسطة',
  enter_meter_value: 'أدخل قيمة العداد',
  add_reading: 'إضافة القراءة',
  select_meter: 'حدد العداد',
  confirm_delete_part_asset:
    'هل أنت متأكد أنك تريد إزالة هذا الجزء من هذا الأصل؟',
  no_due_date: 'لا يوجد تاريخ استحقاق',
  due_at_date: 'تاريخان {{dates}}',
  no_primary_worker: 'لا يوجد عامل أساسي',
  no_wo_linked_asset: 'لا يوجد أمر عمل مرتبط بهذا الأصل',
  asset_remove_success: 'تم حذف الأصل بنجاح',
  asset_remove_failure: 'لم يتم حذف الأصل',
  asset_name_description: 'أدخل اسم الأصل',
  select_asset_location: 'حدد موقع الأصول',
  primary_user_description: 'حدد المستخدم الأساسي',
  teams_description: 'اختر الفرق',
  customers_description: 'اختيار المقاولين',
  vendors_description: 'اختيار البائعين',
  inServiceDate_description: 'تم وضعه في تاريخ الخدمة',
  warranty_expiration_date: 'تاريخ انتهاء الضمان',
  additional_information: 'معلومات إضافية',
  structure: 'بناء',
  parent_asset: 'الأصول الأم',
  asset_create_success: 'تم إنشاء الأصل بنجاح',
  asset_create_failure: 'لم يتمكن من إنشاء الأصل',
  additional_workers_description: 'اختيار العمال الإضافيين',
  required_asset_name: 'اسم الأصل مطلوب',
  add_asset: 'إضافة الأصول',
  add_asset_description: 'املأ الحقول أدناه لإنشاء وإضافة أصل جديد',
  create_asset: 'إنشاء الأصول',
  hierarchy: 'تَسَلسُل',
  add_downtime: 'إضافة وقت التوقف',
  edit_downtime: 'تعديل وقت التوقف',
  remove_downtime: 'إزالة وقت التوقف',
  edit: 'يحرر',
  edit_asset: 'تحرير الأصول',
  edit_asset_description: 'املأ الحقول أدناه لتحرير هذا الأصل',
  confirm_delete_asset: 'هل أنت متأكد أنك تريد حذف هذا الأصل؟',
  loading_assets: 'تحميل الأصول تحت {{name}} #{{id}}',
  no_content: 'لا يوجد محتوى',
  no_result_criteria: 'لا توجد نتيجة تطابق معايير البحث الخاصة بك',
  map_view: 'عرض الخريطة',
  location_create_success: 'تم إنشاء الموقع بنجاح',
  location_create_failure: 'لم يتم إنشاء الموقع',
  location_edit_failure: 'لم يتمكن من تعديل الموقع',
  location_delete_success: 'تم حذف الموقع بنجاح',
  location_delete_failure: 'لم يتم حذف الموقع',
  enter_location_name: 'أدخل اسم الموقع',
  address: 'عنوان',
  parent_location: 'موقع الوالدين',
  select_workers: 'اختيار العمال',
  map_coordinates: 'إحداثيات الخريطة',
  required_location_name: 'عنوان الموقع مطلوب',
  required_location_address: 'عنوان الموقع مطلوب',
  add_location: 'إضافة الموقع',
  add_location_description: 'املأ الحقول أدناه لإنشاء موقع جديد وإضافته',
  edit_location: 'تعديل الموقع',
  edit_location_description: 'إملأ الحقول أدناه لتحديث الموقع',
  confirm_delete_location: 'هل أنت متأكد أنك تريد حذف هذا الموقع؟',
  floor_plans: 'مخططات الطوابق',
  floor_plan: 'مخطط الطابق',
  floor_plan_name_description: 'اسم مخطط الطابق',
  'Floor plan area in m²': 'مساحة مخطط الطابق بالمتر المربع',
  upload_image: 'تحميل صورة',
  required_floor_plan_name: 'اسم مخطط الطابق مطلوب',
  add_floor_plan: 'إضافة مخطط طابق جديد',
  add_floor_plan_description: 'املأ الحقول أدناه لإنشاء مخطط طابق جديد',
  no_asset_in_location: 'لا يوجد أي أصل في هذا الموقع',
  no_wo_in_location: 'لا يوجد أمر عمل في هذا الموقع',
  no_file_in_location: 'لا توجد ملفات مرفقة بهذا الموقع',
  no_floor_plan_in_location: 'لا يوجد مخطط أرضي في هذا الموقع',
  assigned_teams: 'الفرق المخصصة',
  assigned_customers: 'المقاولون المعينون',
  assigned_vendors: 'البائعين المعينين',
  no_access_location:
    'ليس لديك حق الوصول إلى المواقع. يُرجى التواصل مع مسؤول النظام إذا كان لديك حق الوصول.',
  no_access_vendors_customers:
    'ليس لديك حق الوصول إلى البائعين والمقاولين. يُرجى التواصل مع مسؤول النظام إذا كان لديك حق الوصول.',
  no_access_people_team:
    'ليس لديك حق الوصول إلى "الأشخاص والفرق". يُرجى التواصل مع مسؤول النظام إذا كان لديك حق الوصول.',
  no_access_analytics:
    'ليس لديك حق الوصول إلى Analytics. يُرجى التواصل مع مسؤول النظام إذا كان لديك حق الوصول.',
  no_access_assets:
    'ليس لديك حق الوصول إلى الأصول. يُرجى التواصل مع مسؤول النظام إذا كان لديك حق الوصول.',
  no_access_categories:
    'ليس لديك حق الوصول إلى الفئات. يُرجى التواصل مع المسؤول إذا كان لديك حق الوصول.',
  no_access_files:
    'ليس لديك حق الوصول إلى الملفات. يُرجى التواصل مع مسؤول النظام إذا كان لديك حق الوصول.',
  no_access_inventory:
    'ليس لديك حق الوصول إلى "المخزون". يُرجى التواصل مع مسؤول النظام إذا كان لديك حق الوصول.',
  no_access_meters:
    'ليس لديك حق الوصول إلى العدادات. يُرجى التواصل مع مسؤول النظام إذا كان لديك حق الوصول.',
  no_access_purchase_orders:
    'لا يمكنك إنشاء طلب شراء. يُرجى التواصل مع مسؤول النظام إذا كان لديك صلاحية الوصول.',
  no_access_requests:
    'ليس لديك حق الوصول إلى الطلبات. يُرجى التواصل مع مسؤول النظام إذا كان لديك حق الوصول.',
  no_access_settings:
    'ليس لديك حق الوصول إلى الإعدادات. يُرجى التواصل مع مسؤول النظام إذا كان لديك حق الوصول.',
  no_access_page: 'ليس لديك حق الوصول إلى هذه الصفحة',
  file: 'ملف',
  'noRows.location.message': 'تتيح لك المواقع إدارة الأصول والعمال بكفاءة أكبر',
  'noRows.location.action': 'اضغط على زر "+" لإنشاء موقع',
  card_view: 'عرض البطاقة',
  set_create_success: 'تم إنشاء المجموعة بنجاح',
  set_create_failure: 'لم يتم إنشاء المجموعة',
  set_edit_failure: 'لم يتمكن من تحرير المجموعة',
  set_delete_success: 'تم حذف المجموعة بنجاح',
  set_delete_failure: 'لم يتم حذف المجموعة',
  total_cost: 'التكلفة الإجمالية',
  part: 'جزء',
  enter_part_name: 'أدخل اسم الجزء',
  required_set_name: 'اسم المجموعة مطلوب',
  add_set: 'إضافة مجموعة',
  add_set_description: 'املأ الحقول أدناه لإنشاء مجموعة جديدة وإضافتها',
  create_set: 'إنشاء مجموعة',
  edit_set: 'تحرير المجموعة',
  edit_set_description: 'املأ الحقول أدناه لتحرير المجموعة',
  confirm_delete_set: 'هل أنت متأكد أنك تريد حذف هذه المجموعة؟',
  part_create_success: 'تم إنشاء الجزء بنجاح',
  part_create_failure: 'لم يتم إنشاء الجزء',
  part_edit_failure: 'لم يتمكن من تحرير الجزء',
  part_delete_success: 'تم حذف الجزء بنجاح',
  part_delete_failure: 'لم يتم حذف الجزء',
  quantity: 'كمية',
  open_wo: 'أوامر العمل المفتوحة',
  enter_part_category: 'أدخل فئة الجزء',
  enter_part_cost: 'أدخل تكلفة الجزء',
  enter_part_quantity: 'أدخل كمية القطعة',
  minimum_quantity: 'الحد الأدنى للكمية',
  enter_part_minimum_quantity: 'أدخل الحد الأدنى لكمية الجزء',
  non_stock: 'غير الأسهم',
  enter_part_barcode: 'أدخل الرمز الشريطي للجزء',
  enter_part_area: 'أدخل منطقة الجزء',
  additional_part_details: 'تفاصيل الأجزاء الإضافية',
  add_part: 'إضافة جزء',
  add_part_description: 'املأ الحقول أدناه لإنشاء جزء جديد وإضافته',
  create_part: 'إنشاء جزء',
  update_part: 'تحديث الجزء',
  update_part_description: 'املأ الحقول أدناه لتحديث الجزء',
  'noRows.part.message': 'يمكن دمج الأجزاء في الأصول أو استخدامها بمفردها',
  'noRows.part.action': 'اضغط على زر "+" لإنشاء جزء',
  confirm_delete_part: 'هل أنت متأكد أنك تريد حذف هذا الجزء؟',
  part_details: 'تفاصيل القطعة',
  area_details: 'تفاصيل المنطقة',
  assigned_people: 'الأشخاص المعينون',
  no_asset_related_part: 'لا يوجد أصل متعلق بهذا الجزء',
  no_file_found: 'لم يتم العثور على ملف',
  no_wo_found: 'لم يتم العثور على أمر العمل',
  workers: 'العمال',
  Parts_and_Inventory: 'قطع الغيار والمخزون',
  po_edit_failure: 'لم يتم تعديل أمر الشراء',
  po_delete_success: 'تم حذف طلب الشراء بنجاح',
  po_delete_failure: 'لم يتم حذف أمر الشراء',
  number_of_items: 'عدد العناصر',
  total_quantity: 'الكمية الإجمالية',
  shipping_to: 'الشحن إلى',
  shipping_address: 'عنوان الشحن',
  po_details: 'تفاصيل طلب الشراء',
  enter_po_name: 'أدخل اسم طلب الشراء',
  additional_details: 'تفاصيل إضافية',
  vendor: 'بائع',
  shipping_information: 'معلومات الشحن',
  company_name: 'اسم الشركة',
  ship_to: 'سافر على متن سفينة لِـ',
  city: 'مدينة',
  state: 'ولاية',
  zip_code: 'الرمز البريدي',
  fax_number: 'رقم الفاكس',
  po_date: 'تاريخ طلب الشراء',
  notes: 'ملحوظات',
  add_notes: 'إضافة ملاحظات',
  requisitioner: 'طالب الطلب',
  terms: 'شروط',
  shipping_method: 'طريقة الشحن',
  required_name: 'الاسم مطلوب',
  edit_po: 'تعديل طلب الشراء',
  edit_po_description: 'إملأ الحقول أدناه لتحديث طلب الشراء',
  purchase_order: 'أمر شراء',
  'noRows.po.message': 'إدارة طلبات الشراء الخاصة بك في مكان واحد',
  'noRows.po.action': 'اضغط على زر "+" لإنشاء أمر شراء.',
  confirm_delete_po: 'هل أنت متأكد أنك تريد حذف أمر الشراء هذا؟',
  upgrade_po: 'الترقية لإنشاء أوامر الشراء',
  new_po: 'طلب شراء جديد',
  po_create_success: 'تم إنشاء أمر الشراء بنجاح',
  select_one_part: 'حدد جزءًا واحدًا على الأقل',
  po_create_failure: 'لم يتم إنشاء أمر الشراء',
  approve_while_submitting: 'الموافقة أثناء الإرسال',
  invalid_fax: 'رقم الفاكس غير صالح',
  submit: 'يُقدِّم',
  each_item_superior_zero: 'يجب أن تكون كمية كل عنصر أكبر من 0',
  quantity_edit_success: 'تم تغيير الكمية بنجاح',
  quantity_edit_failure: 'لم يتم تغيير الكمية',
  APPROVED: 'موافقة',
  PENDING: 'قيد الانتظار',
  REJECTED: 'مرفوض',
  when_reading_is: 'عندما يتم قراءة العداد',
  greater_than: 'أكبر من',
  lower_than: 'أقل من',
  value: 'قيمة',
  required_value: 'القيمة مطلوبة',
  required_trigger_condition: 'الشرط مطلوب',
  wo_trigger_create_success: 'تم إنشاء مشغل أمر العمل بنجاح',
  wo_trigger_create_failure: 'لم يتم إنشاء مشغل أمر العمل',
  add_wo_trigger: 'إضافة مُشغّل أمر العمل',
  add_wo_trigger_description: 'املأ الحقول أدناه لإنشاء وإضافة مُشغل أمر العمل',
  wo_trigger_edit_success: 'تم تحديث مشغل أمر العمل بنجاح',
  meter_create_success: 'تم إنشاء العداد بنجاح',
  meter_create_failure: 'لم يتم إنشاء العداد',
  meter_edit_failure: 'لم يتمكن من تحرير العداد',
  meter_delete_success: 'تم حذف العداد بنجاح',
  meter_delete_failure: 'لم يتم حذف العداد',
  next_reading_due: 'موعد القراءة القادمة',
  unit_of_measurement: 'وحدة القياس',
  last_reading: 'القراءة الأخيرة',
  enter_meter_name: 'أدخل اسم العداد',
  unit: 'وحدة',
  update_frequency: 'تردد التحديث',
  update_frequency_in_days: 'تردد التحديث بالأيام',
  required_meter_name: 'اسم العداد مطلوب',
  required_meter_unit: 'وحدة القياس مطلوبة',
  required_meter_update_frequency: 'يجب تحديث تردد العداد',
  required_asset: 'الأصول مطلوبة',
  add_meter: 'إضافة عداد',
  add_meter_description: 'املأ الحقول أدناه لإنشاء وإضافة عداد جديد',
  edit_meter: 'تعديل العداد',
  edit_meter_description: 'املأ الحقول أدناه لتحرير العداد',
  confirm_delete_meter: 'هل أنت متأكد أنك تريد حذف هذا العداد؟',
  upgrade_create_meter: 'قم بالترقية لإنشاء العدادات',
  history: 'تاريخ',
  reading_frequency: 'معدل القراءة',
  required_reading_value: 'قيمة القراءة مطلوبة',
  wo_triggers: 'مُحفِّزات أوامر العمل',
  add_trigger: 'إضافة مشغل',
  meter_details: 'تفاصيل العداد',
  'noRows.meter.message':
    'تتيح لك قراءات العدادات القدرة على مراقبة الأصول وإصدار أوامر عمل جديدة بناءً على شروط محددة',
  'noRows.meter.action': 'اضغط على زر "+" لإنشاء عداد',
  meter: 'متر',
  drag_one_file: 'اسحب ملفًا فريدًا هنا',
  drag_many_files: 'اسحب وأفلِت الملفات هنا',
  drop_to_start: 'قم بإسقاط الملفات لبدء التحميل',
  invalid_files_type: 'لا يمكنك تحميل هذه الأنواع من الملفات',
  you_have_uploaded: 'لقد قمت بالتحميل',
  upload: 'رفع',
  Vendors_Customers: 'البائعين والمقاولين',
  customer_create_success: 'تم إنشاء المقاول بنجاح',
  customer_create_failure: 'لم يتمكن من إنشاء المقاول',
  customer_edit_failure: 'لم يتمكن المقاول من التعديل',
  customer_delete_success: 'تم حذف المقاول بنجاح',
  customer_delete_failure: 'لم يتمكن المقاول من الحذف',
  customer_name: 'اسم المقاول',
  website: 'موقع إلكتروني',
  customer_type: 'نوع المقاول',
  customer_type_description: 'على سبيل المثال: السباكة والكهرباء',
  customer_description_description: 'صف غرض هذا المقاول في بضعة أسطر...',
  billing_information: 'معلومات الفوترة',
  address_line_2: 'سطر العنوان 2',
  billing_name: 'اسم الفاتورة',
  currency: 'عملة',
  select_currency: 'اختر العملة',
  required_customer_name: 'اسم المقاول مطلوب',
  required_phone: 'رقم الهاتف مطلوب',
  invalid_website: 'موقع غير صالح',
  billing_address: 'عنوان الفاتورة',
  add_customer: 'إضافة مقاول',
  add_customer_description: 'املأ الحقول أدناه لإنشاء وإضافة مقاول جديد',
  'noRows.customer.message': 'المقاولون هم عمال خارجيون',
  'noRows.customer.action': 'اضغط على زر "+" لإنشاء مقاول',
  type: 'يكتب',
  billing_currency: 'عملة الفاتورة',
  go_back: 'عُد',
  confirm_delete_customer: 'هل أنت متأكد أنك تريد حذف هذا المقاول؟',
  vendor_create_success: 'تم إنشاء البائع بنجاح',
  vendor_create_failure: 'لم يتم إنشاء البائع',
  vendor_edit_failure: 'لم يتمكن البائع من التعديل',
  vendor_delete_success: 'تم حذف البائع بنجاح',
  vendor_delete_failure: 'لم يتم حذف البائع',
  required_company_name: 'اسم الشركة مطلوب',
  vendor_type: 'نوع البائع',
  contact_name: 'اسم جهة الاتصال',
  add_vendor: 'إضافة البائع',
  add_vendor_description: 'املأ الحقول أدناه لإنشاء بائع جديد وإضافته',
  confirm_delete_vendor: 'هل أنت متأكد أنك تريد حذف هذا البائع؟',
  'noRows.vendor.message': 'البائعون هم المنظمات التي توفر الأصول أو الأجزاء',
  'noRows.vendor.action': 'اضغط على زر "+" لإنشاء بائع',
  vendor_type_description: 'على سبيل المثال: السباكة والكهرباء',
  role: 'دور',
  edit_user: 'تعديل المستخدم',
  edit_user_description: 'إملأ الحقول أدناه لتحرير المستخدم',
  job_title: 'مسمى وظيفي',
  invite_users: 'دعوة المستخدمين',
  bring_people_team: 'جلب أشخاص جدد إلى الفريق',
  add_20_users:
    'يمكنك إضافة ٢٠ مستخدمًا في المرة الواحدة بالضغط على "tab" أو "enter" بعد كل إدخال بريد إلكتروني. سيتم حذف أي عناوين بريد إلكتروني مكررة ومسجلة أثناء تسجيل المستخدمين المطلوبين.',
  enter_email: 'أدخل عنوان البريد الإلكتروني',
  users_invite_success: 'تمت دعوة المستخدمين',
  users_invite_failure:
    'لا يمكن دعوة المستخدمين. تحقق من عدد أعضاء اشتراكك الحالي.',
  please_type_emails: 'الرجاء كتابة رسائل البريد الإلكتروني للدعوة',
  please_select_role: 'الرجاء اختيار الدور',
  invite: 'يدعو',
  team_create_success: 'تم إنشاء الفريق بنجاح',
  team_create_failure: 'لم يتمكن من إنشاء الفريق',
  team_edit_failure: 'لم يتمكن الفريق من التعديل',
  team_delete_success: 'تم حذف الفريق بنجاح',
  team_delete_failure: 'لم يتمكن الفريق من الحذف',
  team_name: 'اسم الفريق',
  people_in_team: 'الأشخاص في الفريق',
  required_team_name: 'اسم الفريق مطلوب',
  create_team: 'إنشاء فريق',
  create_team_description: 'يمكنك إضافة أعضاء الفريق من هنا',
  confirm_delete_team: 'هل أنت متأكد أنك تريد حذف هذا الفريق؟',
  overview: 'ملخص',
  activity: 'نشاط',
  wo_complete_last_14_days: 'أوامر العمل المنجزة في آخر 14 يومًا',
  no_wo_complete_last_14_days:
    'لم تقم بإكمال أي أوامر عمل خلال الأسبوعين الماضيين',
  ADMIN_name: 'المسؤول',
  ADMIN_description:
    'يتمتع المسؤول بالوصول الكامل؛ بما في ذلك التحرير والإضافة وحذف أوامر العمل والطلبات',
  LIMITED_ADMIN_name: 'مدير محدود',
  LIMITED_ADMIN_description:
    'يتمتع المسؤولون المحدودون بنفس صلاحيات المسؤول، باستثناء عدم قدرتهم على عرض/تعديل الإعدادات أو إضافة/تعديل الموظفين والفرق. ولا يمكنهم حذف أوامر العمل، ومواقع الأصول، والعدادات، وطلبات الشراء إلا إذا أنشأوا مقاولين، وفئات، ومشغلات إدارة المشروع.',
  TECHNICIAN_name: 'فني',
  TECHNICIAN_description:
    'يمكن للفنيين إنشاء وإغلاق أوامر العمل والأصول والمواقع. كما يمكنهم تعديل وحذف ما أنشأوه فقط.',
  LIMITED_TECHNICIAN_name: 'فني محدود',
  LIMITED_TECHNICIAN_description:
    'لا يمكن للفنيين المحدودين رؤية أوامر العمل المخصصة لهم إلا',
  VIEW_ONLY_name: 'للعرض فقط',
  VIEW_ONLY_description:
    'يتمتع المستخدمون الذين يمكنهم العرض فقط بإمكانية الوصول الكامل للعرض، ولكن لا يمكنهم تعديل أي شيء',
  REQUESTER_name: 'مقدم الطلب',
  REQUESTER_description: 'يمكن للمتقدمين فقط إرسال طلبات العمل وعرض حالتها',
  select_user_role: 'حدد دور المستخدم',
  'noRows.team.message': 'تساعدك الفرق على إدارة مجموعات محددة من الأشخاص.',
  'noRows.team.action': 'اضغط على زر "+" لإنشاء فريق.',
  user_details: 'تفاصيل المستخدم',
  file_delete_success: 'تم حذف الملف بنجاح',
  file_delete_failure: 'لم يتم حذف الملف',
  uploaded_by: 'تم الرفع بواسطة',
  uploaded_on: 'تم التحميل على',
  rename: 'إعادة التسمية',
  required_files: 'الرجاء تحميل ملف واحد على الأقل',
  required_file_name: 'الرجاء إدخال اسم الملف',
  add_files: 'إضافة الملفات',
  edit_file: 'تحرير الملف',
  'noRows.file.message': 'احصل على جميع الملفات في مكان واحد',
  'noRows.file.action': 'اضغط على زر "+" لتحميل الملف',
  upgrade_files:
    'قم بالترقية لاستخدام الملفات في أصولك وأوامر العمل والمواقع وما إلى ذلك...',
  parts_consumption: 'استهلاك الأجزاء',
  requests_analysis: 'تحليل الطلب',
  category_create_success: 'تم إنشاء الفئة بنجاح',
  category_create_failure: 'لم يتم إنشاء الفئة',
  category_edit_failure: 'لم يتم تحرير الفئة',
  category_delete_success: 'تم حذف الفئة بنجاح',
  category_delete_failure: 'لم يتم حذف الفئة',
  timers: 'المؤقتات',
  costs: 'التكاليف',
  add_category: 'إضافة فئة جديدة',
  add_category_description: 'املأ الاسم لإنشاء وإضافة فئة جديدة',
  edit_category: 'تعديل الفئة',
  edit_category_description: 'املأ الاسم لتحرير الفئة',
  no_category_action: 'اضغط على زر "+" لإضافة فئتك الأولى.',
  confirm_delete_category: 'هل أنت متأكد أنك تريد حذف هذه الفئة؟',
  no_category_message: 'يبدو أنه ليس لديك أي فئات {{categoryName}} حتى الآن.',
  acquisition_cost: 'تكلفة الاستحواذ',
  general_settings: 'الإعدادات العامة',
  request_form_configuration: 'تكوين نموذج الطلب',
  roles: 'الأدوار',
  checklists: 'قوائم المراجعة',
  field_configuration_description:
    'يمكنك وضع علامة على الحقول كاختيارية أو مخفية أو مطلوبة',
  optional: 'خياري',
  required: 'مطلوب',
  hidden: 'مختفي',
  creating_wo: 'إنشاء أمر عمل',
  completing_wo: 'إكمال أمر العمل',
  role_edit_failure: 'لم يتمكن من تعديل الدور',
  edit_role: 'تعديل الدور',
  edit_role_description: 'إملأ الحقول أدناه لتحرير الدور',
  external_id: 'معرف خارجي',
  permissions: 'الأذونات',
  create_role_description:
    'يمكن لهذا الدور القيام بكل ما يمكن للمسؤول القيام به في {{shortBrandName}}، ولكن يمكنك تخصيص بعض الأذونات المهمة أدناه.',
  create_and_edit: 'إنشاء/تحرير',
  to_access: 'وصول',
  role_delete_success: 'تم حذف الدور بنجاح',
  role_delete_failure: 'لم يتم حذف الدور',
  confirm_delete_role: 'هل أنت متأكد أنك تريد حذف هذا الدور بشكل دائم؟',
  users: 'المستخدمون',
  paid: 'مدفوع',
  free: 'حر',
  role_create_success: 'تم إنشاء الدور بنجاح',
  role_create_failure: 'لم يتم إنشاء الدور',
  roles_management: 'إدارة الأدوار',
  roles_number: '{{count}} أدوار',
  create_role: 'إنشاء دور',
  upgrade_role: 'الترقية لإنشاء الدور',
  add_role: 'إضافة دور جديد',
  add_role_description: 'املأ الحقول أدناه لإنشاء دور جديد وإضافته',
  parts_and_sets: 'قطع الغيار ومجموعات القطع',
  upgrade_role_edit: 'الترقية إلى دور التحرير',
  delete_role: 'حذف الدور',
  upgrade_role_delete: 'الترقية إلى حذف الدور',
  create: 'يخلق',
  pm_trigger: 'تشغيل الصيانة الوقائية',
  auto_assign_wo: 'التعيين التلقائي لأوامر العمل',
  auto_assign_wo_description:
    'تعيين أوامر العمل الجديدة تلقائيًا للشخص الذي ينشئها',
  auto_assign_requests: 'تخصيص الطلبات تلقائيًا',
  auto_assign_requests_description:
    'تعيين أوامر العمل الجديدة تلقائيًا للشخص الذي يوافق على الطلب',
  disable_closed_wo_notification: 'تعطيل إشعارات أوامر العمل المغلقة',
  disable_closed_wo_notification_description:
    'تعطيل الإشعارات عند تحديث أوامر العمل المغلقة',
  ask_feedback_wo_closed: 'اطلب ردود الفعل عند إغلاق أمر العمل',
  ask_feedback_wo_closed_description:
    'يُطلب من المستخدمين تقديم تعليقات حول المهمة المنجزة',
  include_labor_in_total_cost: 'تضمين تكلفة العمالة في التكلفة الإجمالية',
  include_labor_in_total_cost_description:
    'أضف تكاليف العمالة إلى الإجمالي عندما يسجل المستخدم الوقت ويخزن معدلًا بالساعة',
  enable_wo_updates_requesters: 'تمكين تحديثات أوامر العمل للمتقدمين',
  enable_wo_updates_requesters_description:
    'يحصل المستخدمون على تحديثات لأوامر العمل التي طلبوها',
  language: 'لغة',
  date_format: 'تنسيق التاريخ',
  time_zone: 'المنطقة الزمنية',
  business_type: 'نوع العمل',
  general_asset_management: 'إدارة الأصول العامة',
  physical_asset_management: 'إدارة الأصول المادية',
  checklist_delete_success: 'تم حذف القائمة بنجاح',
  checklist_delete_failure: 'لم يتم حذف القائمة',
  create_checklist: 'إنشاء قائمة التحقق',
  confirm_delete_checklist: 'هل أنت متأكد أنك تريد حذف هذه القائمة؟',
  upgrade_checklist: 'يرجى الترقية لاستخدام قوائم التحقق',
  upgrade_now: 'قم بالترقية الآن',
  total: 'المجموع',
  sub_task_status: 'حالة المهمة الفرعية',
  text_field: 'حقل النص',
  number_field: 'حقل الرقم',
  inspection_check: 'فحص التفتيش',
  multiple_choices: 'اختيارات متعددة',
  meter_reading: 'قراءة العداد',
  select_user: 'حدد المستخدم',
  PASS: 'يمر',
  FLAG: 'علَم',
  FAIL: 'يفشل',
  enter_task_name: 'أدخل اسم المهمة',
  see_details: 'انظر التفاصيل',
  concerned_asset: 'الأصول المعنية',
  me: 'أنا',
  remove_blank_tasks: 'إزالة المهام الفارغة',
  remove_blank_options: 'إزالة الخيارات الفارغة',
  preview: 'معاينة',
  edit_checklist: 'قائمة مراجعة التحرير',
  add_tasks: 'إضافة المهام',
  use_a_checklist: 'استخدم قائمة التحقق',
  select_checklist: 'اختر قائمة التحقق',
  save_checklist: 'حفظ قائمة التحقق',
  assign_tasks_description: 'تعيين مهام مخصصة للفنيين لملئها',
  select_date: 'حدد التاريخ',
  task: 'مهمة',
  checklist: 'قائمة التحقق',
  upgrade_analytics: 'قم بالترقية لرؤية التحليلات',
  grouped_by_category: 'مجمعة حسب الفئة',
  downtime_by_asset: 'وقت التوقف حسب الأصول',
  downtime_and_costs: 'وقت التوقف والتكاليف',
  downtime_and_costs_trends: 'اتجاهات التوقف والتكاليف',
  downtimes_trends: 'اتجاهات أوقات التوقف',
  repair_time_by_asset: 'وقت الإصلاح حسب الأصول',
  consumed_parts_costs: 'تكاليف الأجزاء المستهلكة',
  requests_by_priority: 'الطلبات حسب الأولوية',
  requests_trends: 'اتجاهات الطلبات',
  time_spent: 'الوقت المستغرق',
  grouped_by_completed_by: 'مجمعة حسب مكتملة بواسطة',
  grouped_by_assigned_to: 'مجمعة حسب المعين إلى',
  grouped_by_priority: 'مجمعة حسب الأولوية',
  completion_comparison: 'مقارنة الإكمال',
  hours_worked: 'ساعات العمل',
  work_remaining: 'العمل المتبقي',
  wo_status: 'حالة أمر العمل',
  cost_trends: 'اتجاهات التكلفة',
  cost_center: 'تحليل تكلفة دورة حياة الأصول',
  downtime_and_availability: 'وقت التوقف والتوافر',
  incomplete_wo: 'أوامر العمل غير المكتملة',
  the_numbers: 'الأرقام',
  hours_and_cost_by_asset: 'الساعات والتكلفة حسب الأصول',
  completion_comparison_description:
    'مقارنة بين أنواع مختلفة من أوامر العمل المنجزة.',
  wo_age_description:
    'يتم تعريف عمر أمر العمل على أنه عدد الأيام بين إنشاء أمر العمل (أو طلب العمل) وإكماله.',
  rav_description:
    'التكلفة الإجمالية كنسبة مئوية من القيمة السوقية تساوي (تكلفة أوامر العمل على الأصل / سعر الشراء) × ١٠٠. المعيار الصناعي هو قيمة مستهدفة قدرها ٣٪ لهذا المقياس.',
  downtime_and_availability_description:
    'يشير التوفر إلى نسبة بقاء الأصول في حالة تشغيلية منذ تاريخ وضعها في الخدمة. يشير إجمالي فترات التوقف إلى عدد حالات التوقف التي حدثت خلال الفترة الزمنية المحددة.',
  total_cost_description:
    'تتضمن التكلفة الإجمالية تكلفة العمالة والتكلفة الإضافية وتكلفة الأجزاء في أمر العمل',
  compliant_wo_description:
    'تُعرَّف أوامر العمل الملتزمة بأنها أوامر العمل التي أُنجزت قبل تاريخ الاستحقاق. ويُشير زمن الدورة إلى عدد الأيام المتبقية حتى اكتمال أمر العمل.',
  hours_worked_description:
    'تتوافق هذه الساعات مع أوامر العمل التي لها تاريخ استحقاق ضمن النطاق المحدد في المرشحات.',
  work_remaining_description:
    'يوضح هذا الرسم البياني عدد أوامر العمل غير المكتملة والمستحقة خلال الفترة الزمنية المحددة في عوامل التصفية. تتوافق الساعات المقدرة مع كل أمر عمل على حدة.',
  total_downtime_in_hours: 'إجمالي وقت التوقف (ساعات)',
  downtime_events: 'أحداث التوقف',
  percent_downtime: '% وقت التوقف',
  meantime_between_failures_in_hours: 'متوسط الوقت بين الأعطال (ساعات)',
  availability_percent: 'نسبة التوفر',
  mean_time_to_repair_in_hours: 'متوسط الوقت اللازم للإصلاح (ساعات)',
  average_age: 'متوسط العمر',
  count: 'عدد',
  average_cost: 'متوسط التكلفة',
  compliant: 'متوافق',
  average_cycle_time_in_days: 'متوسط زمن الدورة (أيام)',
  total_consumption_cost: 'إجمالي تكلفة الاستهلاك',
  parts_consumed: 'الأجزاء المستهلكة',
  total_cost_as_pct_rav: 'التكلفة الإجمالية كنسبة مئوية من القيمة السوقية',
  approved_requests: 'الطلبات المعتمدة',
  pending_requests: 'الطلبات المعلقة',
  cancelled_requests: 'الطلبات الملغاة',
  average_cycle_time: 'متوسط وقت الدورة',
  compliance_rate: 'معدل الامتثال',
  complete: 'مكتمل',
  reactive: 'تفاعلي',
  recurring: 'يتكرر',
  part_costs: 'تكاليف الأجزاء',
  labor_costs: 'تكلفة العمالة',
  total_time_spent_in_hours: 'إجمالي الوقت المستغرق (ساعات)',
  estimated_hours: 'الساعات المقدرة',
  total_purchase_price: 'إجمالي سعر الشراء',
  you_have: 'لديك',
  new_messages: 'رسائل جديدة',
  company: 'شركة',
  change_cover: 'تغيير الغطاء',
  required_address: 'حقل العنوان مطلوب',
  company_details: 'تفاصيل الشركة',
  company_details_description: 'إدارة المعلومات المتعلقة بشركتك',
  learn_more: 'يتعلم أكثر',
  profile: 'حساب تعريفي',
  email_notifications: 'إشعارات البريد الإلكتروني',
  email_updates_wo: 'تحديثات البريد الإلكتروني لأوامر العمل والرسائل',
  email_updates_requests: 'تحديثات البريد الإلكتروني لأوامر العمل المطلوبة',
  po_emails: 'رسائل البريد الإلكتروني لطلبات الشراء',
  required_job_title: 'حقل عنوان الوظيفة مطلوب',
  required_old_password: 'يرجى تقديم كلمة المرور الحالية.',
  invalid_password:
    'كلمة المرور قصيرة جدًا - يجب أن تتكون من 8 أحرف على الأقل.',
  required_new_password: 'لم يتم توفير كلمة المرور.',
  passwords_must_match: 'يجب أن تتطابق كلمات المرور',
  password_change_success: 'تم تغيير كلمة المرور بنجاح',
  wrong_password: 'تم إدخال كلمة مرور خاطئة',
  current_password: 'كلمة المرور الحالية',
  new_password: 'كلمة المرور الجديدة',
  confirm_password: 'تأكيد كلمة المرور',
  personal_details: 'البيانات الشخصية',
  personal_details_description: 'إدارة المعلومات المتعلقة بتفاصيلك الشخصية',
  change_password: 'تغيير كلمة المرور',
  notification_settings: 'إعدادات الإشعارات',
  notification_settings_description: 'إدارة التفاصيل المتعلقة بإشعاراتك',
  recent_activity: 'النشاط الأخير',
  created: 'مخلوق',
  completed: 'مكتمل',
  my_account: 'حسابي',
  my_company: 'شركتي',
  you_are_using_plan:
    'أنت تستخدم حاليًا خطة {{planName}}. ستنتهي صلاحيتها في {{expiration}}. بادر بالترقية الآن للحصول على المزيد من الميزات.',
  upgrade_plan: 'خطة الترقية',
  plans: 'الخطط',
  monthly: 'شهريا',
  annually: 'سنويا',
  subscription_change_success: 'تم تغيير الاشتراك بنجاح',
  invalid_credit_card: 'رقم بطاقة الائتمان غير صالح',
  required_credit_card: 'حقل البطاقة مطلوب',
  invalid_expiration_month: 'شهر انتهاء الصلاحية غير صالح',
  required_expiration_month: 'شهر انتهاء الصلاحية مطلوب',
  invalid_expiration_year: 'سنة انتهاء الصلاحية غير صالحة',
  required_expiration_year: 'سنة انتهاء الصلاحية مطلوبة',
  invalid_cvv: 'رمز CVV غير صالح',
  required_cvv: 'يجب أن يكون رمز CVV مطلوبًا',
  required_cardholder_name: 'اسم حامل البطاقة مطلوب',
  card: 'بطاقة',
  expiration_month: 'شهر انتهاء الصلاحية',
  expiration_year: 'سنة انتهاء الصلاحية',
  cardholder_name: 'اسم حامل البطاقة',
  seats: 'المقاعد',
  cost_per_seat: 'التكلفة لكل مقعد',
  your_payment_secure: 'بيانات الدفع الخاصة بك مشفرة وآمنة.',
  plan: 'يخطط',
  current_plan: 'الخطة الحالية',
  number_users_who_will_use_grash:
    'عدد المستخدمين الذين سيستخدمون {{shortBrandName}}',
  admin_role: 'مسؤل',
  technical_role: 'اِصطِلاحِيّ',
  limited_technical_role: 'تقنية محدودة',
  requester_role: 'مقدم الطلب',
  view_only_role: 'للعرض فقط',
  how_will_you_be_billed: 'كيف تريد أن يتم تحصيل الرسوم منك؟',
  which_plan_fits_you: 'ما هي الخطة التي تناسبك بشكل أفضل؟',
  per_user_month: 'لكل مستخدم/شهر',
  per_user_year: 'لكل مستخدم/سنة',
  you_will_be_charged: 'سيتم محاسبتك',
  proceed_to_payment: 'انتقل إلى الدفع',
  pay_only_for_roles:
    'ادفع فقط للمستخدمين <strong>الإداريين</strong> <strong>والفنيين</strong> والمستخدمين <strong>الفنيين المحدودين</strong> ، واستخدم عددًا غير محدود <strong>من المستخدمين</strong> <strong>للعرض فقط</strong> مجانًا',
  checkout_our: 'تحقق من موقعنا',
  pricing_page: 'صفحة التسعير',
  for_more_details: 'لمزيد من التفاصيل',
  users_count_display: '{{count}} مستخدمين',
  monthly_adverb: 'شهريا',
  yearly_adverb: 'سنوي',
  features: 'سمات',
  checkout: 'الدفع',
  checkout_description: 'إملأ الحقول أدناه',
  per_month: 'كل شهر',
  per_year: 'كل سنة',
  recover_password_description:
    'أدخل البريد الإلكتروني الذي استخدمته للتسجيل لإعادة تعيين كلمة المرور الخاصة بك.',
  send_me_new_password: 'أرسل لي كلمة مرور جديدة',
  want_to_sign_in_again: 'هل تريد محاولة تسجيل الدخول مرة أخرى؟',
  check_mails_for_instructions:
    'تحقق من بريدك الإلكتروني للحصول على مزيد من التعليمات',
  pdf_report: 'تقرير PDF',
  HIGH: 'عالي',
  MEDIUM: 'واسطة',
  LOW: 'قليل',
  NONE: 'لا أحد',
  import: 'يستورد',
  start_import_process: 'بدء عملية الاستيراد',
  import_data: 'استيراد البيانات',
  set_header: 'تعيين الرأس',
  match_columns: 'أعمدة المباراة',
  review: 'مراجعة',
  done: 'منتهي',
  no_match_yet: 'لا يوجد تطابق حتى الآن',
  select: 'يختار...',
  matched_to_field: 'مطابق لـ {{field}}',
  next: 'التالي',
  not_enough_rows: 'لا يوجد عدد كاف من الصفوف في الملف',
  there_are_duplicates: 'هناك مكررات: {{duplicates}}',
  assigned_by: 'تم التعيين بواسطة',
  percent_rows_have_value: '{{percent}}% من الصفوف لها قيمة',
  match_at_least_column: 'تطابق عمود واحد على الأقل',
  to_import: 'يستورد',
  required_match: 'مطلوب مطابقة {{field}}',
  archived: 'مؤرشفة',
  import_wo_success: 'تم إنشاء أوامر العمل {{created}} وتم تحديث {{updated}}',
  to_export: 'يصدّر',
  filters: 'المرشحات',
  more_filters: 'المزيد من المرشحات',
  customer: 'مقاول',
  to: 'ل',
  dates: 'بلح',
  start: 'يبدأ',
  end: 'نهاية',
  longitude: 'خط الطول',
  latitude: 'خط العرض',
  ALL: 'الجميع',
  REACTIVE: 'تفاعلي',
  REPEATING: 'وقائي',
  import_location_success:
    'تم إنشاء {{created}} موقعًا وتم تحديث {{updated}} موقعًا',
  import_part_success: 'تم إنشاء {{created}} أجزاء وتم تحديث {{updated}} أجزاء',
  import_meter_success: 'تم إنشاء {{created}} عدادات وتم تحديث {{updated}}',
  import_asset_success: 'تم إنشاء الأصول {{created}} وتم تحديثها {{updated}}',
  wo_calendar: 'تقويم أوامر العمل',
  month: 'شهر',
  week: 'أسبوع',
  day: 'يوم',
  agenda: 'جدول الأعمال',
  previous: 'سابق',
  today: 'اليوم',
  to_filter: 'فلتر',
  'noRows.asset.message': 'الأصول هي الموارد التي يمكن لشركتك التدخل فيها',
  'noRows.asset.action': 'اضغط على زر "+" لإنشاء أصل جديد.',
  reset_filters: 'إعادة تعيين المرشحات',
  toggle_menu: 'تبديل القائمة',
  no_results: 'لم يتم العثور على نتائج',
  an_error_occured: 'حدث خطأ.',
  density: 'كثافة',
  compact: 'مضغوط',
  standard: 'معيار',
  comfortable: 'مريح',
  columns: 'الأعمدة',
  select_columns: 'تحديد الأعمدة',
  show_filters: 'إظهار المرشحات',
  hide_filters: 'إخفاء المرشحات',
  search_placeholder: 'يبحث…',
  search: 'يبحث',
  clear: 'واضح',
  download_as_csv: 'تنزيل بصيغة CSV',
  print: 'مطبعة',
  download_as_excel: 'تنزيل كملف Excel',
  find_column: 'البحث عن العمود',
  column_title: 'عنوان العمود',
  reorder_column: 'إعادة ترتيب العمود',
  show_all: 'إظهار الكل',
  hide_all: 'إخفاء الكل',
  add_filter: 'إضافة مرشح',
  logic_operator: 'عامل منطقي',
  operator: 'المشغل',
  and: 'و',
  or: 'أو',
  filter_value: 'قيمة الفلتر',
  contains: 'يتضمن',
  equals: 'يساوي',
  starts_with: 'يبدأ بـ',
  ends_with: 'ينتهي بـ',
  is: 'يكون',
  is_not: 'ليس كذلك',
  is_after: 'هو بعد',
  is_on_or_after: 'هو على أو بعد',
  is_before: 'هو قبل',
  is_on_or_before: 'هو في أو قبل',
  is_empty: 'فارغ',
  is_not_empty: 'ليس فارغا',
  is_any_of: 'هل أي من',
  any: 'أي',
  true_text: 'حقيقي',
  false_text: 'خطأ شنيع',
  menu: 'قائمة طعام',
  show_columns: 'إظهار الأعمدة',
  hide: 'يخفي',
  unsort: 'إلغاء الفرز',
  sort_by_ASC: 'فرز حسب ASC',
  sort_by_DESC: 'فرز حسب DESC',
  sort: 'نوع',
  total_rows: 'إجمالي الصفوف:',
  yes: 'نعم',
  no: 'لا',
  more: 'أكثر',
  to_group: 'مجموعة',
  see_children: 'رؤية الأطفال',
  hide_children: 'إخفاء الأطفال',
  expand: 'يوسع',
  collapse: 'ينهار',
  detail_panel_toggle: 'تبديل لوحة التفاصيل',
  cancel_subscription: 'إلغاء الاشتراك',
  resume_subscription: 'استئناف الاشتراك',
  confirm_cancel_subscription: 'هل أنت متأكد أنك تريد إلغاء الاشتراك؟',
  workflows: 'سير العمل',
  create_workflow: 'إنشاء سير العمل',
  if: 'لو',
  and_optional: 'و(اختياري)',
  then: 'ثم',
  workflow_description:
    'أنشئ مهام سير عمل مخصصة بسهولة تامة. وفر وقتك وخصص أوامر عملك تلقائيًا من خلال مهام سير العمل لتخصيص أطلس بما يتناسب مع طريقة عمل فريقك.\n\nتتيح جميع الخطط إنشاء ما يصل إلى مهمة سير عمل مخصصة واحدة. لإضافة مهام سير عمل إضافية، قم بالترقية إلى خطة الأعمال.',
  CREATE_PURCHASE_ORDER: 'إنشاء طلب شراء',
  PART_IS: 'الجزء هو',
  QUANTITY_INFERIOR: 'الكمية أقل من',
  ASSIGN_VENDOR: 'تعيين البائع',
  ASSIGN_CATEGORY: 'تعيين الفئة',
  APPROVE: 'يعتمد',
  REJECT: 'يرفض',
  SEND_REMINDER_EMAIL: 'إرسال بريد إلكتروني تذكيري',
  VENDOR_IS: 'البائع هو',
  CATEGORY_IS: 'الفئة هي',
  STATUS_IS: 'الحالة هي',
  DUE_DATE_BETWEEN: 'تاريخ الاستحقاق هو بين',
  DUE_DATE_AFTER: 'تاريخ الاستحقاق هو بعد',
  ASSIGN_PRIORITY: 'تعيين الأولوية',
  ASSIGN_ASSET: 'تعيين الأصول',
  ASSIGN_LOCATION: 'تعيين الموقع',
  ASSIGN_USER: 'تعيين المستخدم',
  ASSIGN_TEAM: 'تعيين الفريق',
  ADD_CHECKLIST: 'إضافة قائمة التحقق',
  PRIORITY_IS: 'الأولوية هي',
  ASSET_IS: 'الأصل هو',
  LOCATION_IS: 'الموقع هو',
  USER_IS: 'المستخدم هو',
  TEAM_IS: 'الفريق هو',
  CREATED_AT_BETWEEN: 'يتم إنشاؤه بين',
  TITLE_CONTAINS: 'العنوان يحتوي على',
  CREATE_REQUEST: 'إنشاء طلب',
  CREATE_WORK_ORDER: 'إنشاء أمر عمل',
  SET_ASSET_STATUS: 'تعيين حالة الأصول',
  NAME_IS: 'الاسم هو',
  NAME_CONTAINS: 'الاسم يحتوي على',
  VALUE_IS: 'القيمة هي',
  VALUE_CONTAINS: 'القيمة تحتوي على',
  NUMBER_VALUE_SUPERIOR: 'القيمة أعلى من',
  NUMBER_VALUE_INFERIOR: 'القيمة أقل من',
  WORK_ORDER_CREATED: 'يتم إنشاء أمر العمل',
  WORK_ORDER_CLOSED: 'تم إغلاق أمر العمل',
  WORK_ORDER_ARCHIVED: 'تم أرشفة أمر العمل',
  REQUEST_CREATED: 'تم إنشاء الطلب',
  REQUEST_APPROVED: 'تمت الموافقة على الطلب',
  REQUEST_REJECTED: 'تم رفض الطلب',
  PURCHASE_ORDER_CREATED: 'تم إنشاء أمر شراء',
  PURCHASE_ORDER_UPDATED: 'تم تحديث أمر الشراء',
  TASK_UPDATED: 'تم تحديث المهمة',
  PART_UPDATED: 'تم تحديث جزء',
  add_condition: 'إضافة شرط',
  workflow_creation_success: 'تم إنشاء سير العمل بنجاح',
  workflow_creation_failure: 'لم ينجح إنشاء سير العمل',
  action_value_missing: 'قيمة الإجراء مفقودة',
  condition_value_missing: 'قيمة الشرط مفقودة',
  workflow_edit_success: 'تم تحديث سير العمل بنجاح',
  workflow_edit_failure: 'لم يتمكن من تحرير سير العمل',
  workflow_delete_success: 'تم حذف سير العمل بنجاح',
  workflow_delete_failure: 'لم يتمكن من حذف سير العمل',
  confirm_delete_workflow: 'هل أنت متأكد أنك تريد حذف سير العمل هذا؟',
  click_here: 'انقر هنا',
  verify_email_title: 'التحقق من البريد الإلكتروني',
  verify_email_description:
    'تم إرسال رسالة تحقق إليك. تحقق من البريد العشوائي إذا لم تجدها في بريدك الوارد.',
  upgrade: 'يرقي',
  downgrade: 'تخفيض الإصدار',
  upgrade_description:
    'لقد قمتَ بترقية اشتراكك. عليكَ تفعيل خدمة {{shortBrandName}} للمستخدمين ذوي الإعاقة. يمكنكَ القيام بذلك مرة واحدة فقط للاشتراك الحالي. يُرجى اختيار الخيار بعناية.',
  enable_users: 'تمكين المستخدمين',
  max_users_description: 'يمكنك تمكين ما يصل إلى {{maxUsers}} مستخدمين',
  downgrade_description:
    'لقد خفضت اشتراكك مؤخرًا. عليك تعطيل بعض المستخدمين للمتابعة. يمكنك القيام بذلك مرة واحدة فقط للاشتراك الحالي. يُرجى الاختيار بعناية.',
  disable_users: 'تعطيل المستخدمين',
  min_users_description: 'يجب عليك تعطيل ما لا يقل عن {{minUsers}} مستخدم',
  downgrade_description_no_owner:
    'قامت شركتك للتو بتخفيض باقة اشتراكها. يجب على مالك الشركة تعطيل بعض المستخدمين قبل المتابعة.',
  past_due: 'متأخر',
  due_date_delay: 'تأخير تاريخ الاستحقاق',
  due_date_delay_description: 'تأخير تاريخ الاستحقاق بالأيام',
  days_count: '{{أيام}} يوم',
  trigger_configuration: 'تكوين المشغل',
  WORK_ORDER_feature: 'أوامر العمل',
  REQUEST_feature: 'طلبات العمل',
  PART_feature: 'إدارة الأجزاء',
  MOBILE_APP_feature: 'تطبيق الجوال',
  WORK_ORDER_HISTORY_feature: 'سجل أوامر العمل',
  PREVENTIVE_MAINTENANCE_feature: 'الصيانة الوقائية',
  CHECKLIST_feature: 'قوائم المراجعة',
  FILE_feature: 'تحميل الملفات',
  PURCHASE_ORDER_feature: 'طلبات الشراء',
  METER_feature: 'قراءات العدادات',
  REQUEST_CONFIGURATION_feature: 'تكوين نموذج الطلب',
  ADDITIONAL_TIME_feature: 'تتبع الوقت المتقدم',
  ADDITIONAL_COST_feature: 'تتبع التكاليف المتقدم',
  ANALYTICS_feature: 'التحليلات والتقارير',
  REQUEST_PORTAL_feature: 'بوابة الطلبات',
  SIGNATURE_feature: 'التوقيعات',
  ROLE_feature: 'الأدوار المخصصة',
  WORKFLOW_feature: 'أتمتة سير العمل',
  API_ACCESS_feature: 'الوصول إلى واجهة برمجة التطبيقات',
  WEBHOOK_feature: 'خطافات الويب',
  add_new_option: 'إضافة خيار جديد',
  edit_company: 'تحرير الشركة',
  fill_fields_below: 'إملأ الحقول أدناه',
  IMPORT_CSV_feature: 'استيراد CSV',
  no_import_access: 'قم بترقية خطتك لاستيراد ملفات CSV وExcel',
  members: 'أعضاء',
  assign_user: 'تعيين المستخدم',
  assign_asset: 'تعيين الأصول',
  required_files_on_completion: 'الملفات مطلوبة عند إكمال أمر العمل',
  required_tasks_on_completion: 'يجب إكمال المهام',
  required_labor_on_completion: 'يجب عليك تسجيل الوقت',
  required_part_on_completion: 'لم يتم استخدام أي جزء في أمر العمل هذا',
  required_cost_on_completion: 'لا توجد معلومات عن التكلفة في أمر العمل هذا',
  estimated_hours_in_text: '{{hours}} ساعة تقديرية',
  required_part_name: 'اسم الجزء مطلوب',
  asset_update_failure: 'لم يتمكن من تحرير الأصل',
  terms_of_service: 'شروط الخدمة',
  privacy_policy: 'سياسة الخصوصية',
  last_login: 'آخر تسجيل دخول',
  not_enough_part: 'لا يوجد ما يكفي من هذا الجزء',
  remove_blank_meter_tasks:
    'إزالة المهام التي تحتوي على عداد من النوع بدون عداد',
  checklist_update_failure: 'لم يكن من الممكن تعديل القائمة',
  contact_us: 'اتصل بنا',
  simplify_wo: 'تبسيط أوامر العمل في تطبيق الهاتف المحمول',
  simplify_wo_description:
    'إخفاء عناصر التحكم في الوقت والتكاليف والأجزاء في تفاصيل أمر العمل أثناء استخدام تطبيق الهاتف المحمول',
  account_deletion: 'حذف حساب {{brandName}}',
  switch_account: 'تبديل الحساب',
  switch_to_super_user: 'التبديل إلى المشرف الأعلى',
  switch_account_description: 'الرجاء اختيار حساب للمتابعة',
  put_location_in_map: 'ضع الموقع على الخريطة',
  confirm_disable_user:
    'هل أنت متأكد من رغبتك في تعطيل {{user}}؟ لن تتمكن من تفعيله إلا بعد شهر واحد.',
  user_disabled_success: 'تم تعطيل المستخدم بنجاح',
  disable: 'إبطال',
  manufacturer: 'الشركة المصنعة',
  power: 'قوة',
  import_error: 'لم ينجح الاستيراد',
  request_upgrade: 'طلب الترقية',
  operation_success: 'العملية ناجحة',
  CANCELLED: 'مرفوض',
  uptime_hours: 'وقت التشغيل (ساعة)',
  downtime_hours: 'وقت التوقف (ساعة)',
  mark_all_as_seen: 'وضع علامة على كل شيء كما هو موضح',
  estimation_accuracy_ratio: 'نسبة دقة التقدير',
  download_template: 'تنزيل القالب',
  pareto_by_total_price: 'باريتو حسب السعر الإجمالي',
  cumulative_percent: 'النسبة المئوية التراكمية',
  part_consumption_by_asset: 'الاستهلاك الجزئي حسب الأصول',
  grouped_by_wo_category: 'مجمعة حسب فئة أمر العمل',
  resolution_rate: 'معدل الدقة',
  resolved: 'تم الحل',
  average: 'متوسط',
  documentation: 'التوثيق',
  days_before_pm_notification: 'إشعارات ما قبل أوامر العمل المجدولة',
  estimated_start_date: 'تاريخ البدء المتوقع',
  no_file_linked_to_wo: 'لا يوجد ملف مرفق بأمر العمل هذا',
  add_file: 'إضافة ملف',
  try_for_free: 'جربه مجانا',
  choose_your_plan: 'اختر خطتك',
  STARTER_description:
    'الفرق التي تسعى إلى بناء صيانة وقائية فعالة وقوية من خلال رؤية حالة الآلات والقوى العاملة.',
  PROFESSIONAL_description:
    'الأقسام التي تحتاج إلى الاستفادة من الرؤى والتحليلات لتحقيق المزيد من النمو والإنتاجية في مجال الصيانة.',
  BUSINESS_description:
    'المنظمات جاهزة لالتقاط بيانات الصيانة والعمليات لإدارة مواقع متعددة وتخصيص النظام.',
  book_demo: 'احجز عرضًا توضيحيًا',
  request_pricing: 'طلب التسعير للحصول على مزيد من المعلومات',
  Reports: 'التقارير',
  'Custom dashboard built using the included components':
    'لوحة معلومات مخصصة تم إنشاؤها باستخدام المكونات المضمنة',
  Export: 'يصدّر',
  'Last year': 'العام الماضي',
  Expenses: 'نفقات',
  Statistics: 'إحصائيات',
  General: 'عام',
  Calendar: 'تقويم',
  Mailbox: 'صندوق البريد',
  Dashboards: 'لوحات المعلومات',
  Analytics: 'التحليلات',
  Monitoring: 'يراقب',
  Tasks: 'المهام',
  Applications: 'التطبيقات',
  Users: 'المستخدمون',
  'List All': 'قائمة الكل',
  'User Profile': 'ملف تعريف المستخدم',
  Login: 'تسجيل الدخول',
  Register: 'يسجل',
  'Recover Password': 'استعادة كلمة المرور',
  Status: 'حالة',
  'Error 404': 'خطأ 404',
  'Error 500': 'خطأ 500',
  'Coming Soon': 'قريباً',
  Maintenance: 'صيانة',
  Overview: 'ملخص',
  Documentation: 'التوثيق',
  Welcome: 'مرحباً',
  Help: 'يساعد',
  'Features tour': 'جولة الميزات',
  'Getting started guide': 'دليل البدء',
  'Contact support': 'اتصل بالدعم',
  Version: 'إصدار',
  Search: 'يبحث',
  Notifications: 'إشعارات',
  Settings: 'إعدادات',
  'Language Switcher': 'مُبدِّل اللغة',
  'Sign out': 'تسجيل الخروج',
  'Change Theme': 'تغيير الثيم',
  'View all notifications': 'عرض جميع الإشعارات',
  rate: 'معدل',
  select_at_least_column: 'حدد عمودًا واحدًا على الأقل',
  already_read: 'لقد قرأت بالفعل',
  OPERATIONAL: 'التشغيلية',
  DOWN: 'تحت',
  MODERNIZATION: 'تحديث',
  STANDBY: 'تعليق',
  INSPECTION_SCHEDULED: 'تم جدولة التفتيش',
  COMMISSIONING: 'التشغيل',
  EMERGENCY_SHUTDOWN: 'إغلاق الطوارئ',
  select_asset_status: 'حدد حالة الأصول',
  asset_status: 'حالة الأصول',
  ui_configuration: 'تكوين واجهة المستخدم',
  password_leave_empty_if_you_dont_want_to_change:
    'كلمة المرور - اتركها فارغة إذا كنت لا تريد تغييرها',
  continue_with_sso: 'استمر مع تسجيل الدخول',
  see_live_demo: 'عرض العرض المباشر',
  csv_separator: 'محدد CSV',
  open_source_cmms: 'نظام صيانة مفتوح المصدر (CMMS)',
  'main.title': 'نظام صيانة مجاني مفتوح المصدر (برنامج إدارة الصيانة)',
  'home.h1':
    'نظام CMMS مجاني ومفتوح المصدر يمكنك استضافته ذاتيًا أو استخدامه في السحابة',
  'home.h2': 'صيانة قوية بتكلفة منخفضة',
  'home.h3':
    'توقف عن الاعتماد على جداول البيانات والسبورات البيضاء. يساعد {{brandName}} فرق الصيانة على تخطيط التدخلات وتتبع المعدات والبقاء ممتثلاً. استضف ذاتيًا على خادمك الخاص أو ابدأ فورًا في السحابة.',
  talk_to_sales: 'تحدث إلى المبيعات',
  'pricing.choose_plan_and_get_started': 'اختر خطتك وابدأ.',
  'pricing.slogan_effective_maintenance':
    'يوفر برنامجنا لفرق الصيانة والموثوقية الأدوات التي يحتاجونها لإدارة العمليات بكفاءة وفعالية.',
  'pricing.compare_plans_and_pricing': 'قارن بين الخطط والأسعار',
  'pricing.see_which_plan_is_right_for_you': 'تعرف على الخطة المناسبة لك',
  'pricing.select_two_plans_to_compare': 'اختر خطتين للمقارنة',
  'pricing.select_three_plans_to_compare': 'اختر 3 خطط للمقارنة',
  'pricing.month_per_user': 'شهريًا لكل مستخدم',
  'pricing.year_per_user': 'سنة لكل مستخدم',
  'pricing.plan_basic_name': 'أساسي',
  'pricing.plan_basic_description':
    'الفرق التي تتطلع إلى تتبع الأصول وإنشاء جداول صيانة وقائية أساسية مع إجراءات محددة.',
  'pricing.feature_unlimited_work_orders': 'أوامر عمل غير محدودة',
  'pricing.feature_custom_tasks': 'المهام المخصصة',
  'pricing.feature_unlimited_request_user_licenses':
    'تراخيص مستخدمين غير محدودة الطلبات',
  'pricing.plan_starter_name': 'بداية',
  'pricing.plan_starter_description':
    'الفرق التي تتطلع إلى بناء صيانة وقائية فعالة وقوية من خلال حالة الآلات ورؤية القوى العاملة.',
  'pricing.feature_everything_in_basic_plus':
    'كل شيء في النسخة الأساسية بالإضافة إلى:',
  'pricing.feature_preventive_maintenance_recurring_work_orders':
    'أوامر العمل الوقائية/المتكررة',
  'pricing.feature_custom_checklists': 'قوائم التحقق المخصصة',
  'pricing.feature_inventory_management_costing':
    'إدارة المخزون / حساب التكاليف',
  'pricing.feature_time_and_manpower_tracking': 'تتبع الوقت والقوى العاملة',
  'pricing.feature_thirty_day_analytics_reporting':
    'التحليلات والتقارير لمدة 30 يومًا',
  'pricing.plan_professional_name': 'احترافي',
  'pricing.plan_professional_description':
    'الإدارات التي تحتاج إلى الاستفادة من الرؤى والتحليلات لدفع نمو الصيانة والإنتاجية بشكل أكبر.',
  'pricing.feature_everything_in_starter_plus':
    'كل ما في باقة Starter بالإضافة إلى:',
  'pricing.feature_multiple_inventory_lines': 'بنود جرد متعددة',
  'pricing.feature_customizable_request_portal': 'بوابة طلبات قابلة للتخصيص',
  'pricing.feature_mobile_offline_mode':
    'وضع عدم الاتصال بالإنترنت على الهاتف المحمول',
  'pricing.feature_advanced_analytics_reporting':
    'التحليلات المتقدمة وإعداد التقارير',
  'pricing.plan_business_name': 'عمل',
  'pricing.plan_business_description':
    'المنظمات الجاهزة لجمع بيانات الصيانة والتشغيل لإدارة مواقع متعددة وتخصيص النظام.',
  'pricing.feature_everything_in_professional_plus':
    'كل شيء في النسخة الاحترافية بالإضافة إلى:',
  'pricing.feature_purchase_order_management': 'إدارة أوامر الشراء',
  'pricing.feature_multi_site_module_support':
    'دعم الوحدات النمطية متعددة المواقع',
  'pricing.feature_custom_work_order_statuses': 'حالات أوامر العمل المخصصة',
  'pricing.feature_custom_integrations_support': 'دعم عمليات التكامل المخصصة',
  'pricing.feature_work_order_management': 'إدارة أوامر العمل',
  'pricing.feature_recurring_work_orders': 'أوامر العمل المتكررة',
  'pricing.feature_custom_categories': 'فئات مخصصة',
  'pricing.feature_data_importing': 'استيراد البيانات',
  'pricing.feature_time_and_cost_tracking': 'تتبع الوقت والتكلفة',
  'pricing.feature_work_order_configuration': 'تكوين أمر العمل',
  'pricing.feature_internal_requests': 'الطلبات الداخلية',
  'pricing.feature_external_request_portal': 'بوابة الطلبات الخارجية',
  'pricing.category_locations_assets_parts': 'المواقع والأصول والأجزاء',
  'pricing.feature_location_management': 'إدارة المواقع',
  'pricing.feature_barcode_scanning': 'مسح الباركود',
  'pricing.feature_inventory_management': 'إدارة المخزون',
  'pricing.feature_custom_asset_statuses': 'حالات الأصول المخصصة',
  'pricing.feature_asset_downtime_tracking': 'تتبع وقت تعطل الأصول',
  'pricing.feature_asset_depreciation_tracking': 'تتبع استهلاك الأصول',
  'pricing.feature_asset_warranty_tracking': 'تتبع ضمان الأصول',
  'pricing.feature_purchase_orders_management': 'أوامر الشراء',
  'pricing.feature_asset_check_in_out': 'تسجيل دخول/خروج الأصول',
  'pricing.category_mobile_offline':
    'وضع عدم الاتصال بالإنترنت على الهاتف المحمول',
  'pricing.feature_work_order_availability': 'توافر أوامر العمل',
  'pricing.feature_updating_status': 'تحديث الحالة',
  'pricing.feature_updating_tasks': 'تحديث المهام',
  'pricing.feature_work_order_drafts': 'مسودات أوامر العمل',
  'pricing.feature_full_drill_down_reporting_history': 'تقارير مفصلة وسجل كامل',
  'pricing.period_thirty_days': '30 يومًا',
  'pricing.period_full': 'ممتلىء',
  'pricing.feature_pdf_csv_exporting': 'تصدير ملفات PDF و CSV',
  'pricing.feature_itemized_time_reporting': 'تقرير الوقت المفصل',
  'pricing.feature_user_login_reports': 'تقارير تسجيل دخول المستخدم',
  'pricing.feature_parts_consumption_reports': 'تقارير استهلاك قطع الغيار',
  'pricing.feature_asset_downtime_reports': 'تقارير تعطل الأصول',
  'pricing.feature_equipment_reliability_reports': 'تقارير موثوقية المعدات',
  'pricing.feature_multi_site_modules': 'وحدات متعددة المواقع',
  'pricing.category_integrations': 'التكاملات',
  'pricing.feature_business_integrations':
    'تكامل الأعمال (SAP/Oracle/الذكاء الاصطناعي السببي...)',
  'pricing.feature_custom_integrations': 'عمليات التكامل المخصصة',
  'pricing.feature_unlimited_view_only_users':
    'عدد غير محدود من المستخدمين للعرض فقط',
  'pricing.feature_unlimited_requesters': 'عدد غير محدود من مقدمي الطلبات',
  'pricing.feature_unlimited_vendors': 'عدد غير محدود من البائعين',
  'pricing.feature_unlimited_customers': 'عدد غير محدود من العملاء',
  'pricing.category_support': 'يدعم',
  'pricing.feature_daily_email_digest': 'ملخص البريد الإلكتروني اليومي',
  'pricing.feature_articles': 'مقالات',
  'pricing.feature_training_webinars': 'ندوات تدريبية عبر الإنترنت',
  'pricing.feature_community_support_discord': 'دعم المجتمع (ديسكورد)',
  'pricing.feature_email_support': 'دعم عبر البريد الإلكتروني',
  'pricing.feature_chat_phone_support': 'الدعم عبر الدردشة/الهاتف',
  'pricing.feature_priority_support': 'دعم ذو أولوية',
  'pricing.feature_implementation_training': 'التنفيذ والتدريب',
  'pricing.feature_dedicated_account_manager': 'مدير حسابات مخصص',
  'pricing.category_customization': 'التخصيص',
  'pricing.feature_custom_development': 'التطوير المخصص',
  'pricing.sh_plan_basic_name': 'أساسي',
  'pricing.sh_plan_basic_description':
    'للفرق الصغيرة التي تحتاج إلى سيادة كاملة على البيانات وتتبع الصيانة الأساسية على بنيتها التحتية الخاصة.',
  'pricing.sh_feature_core_work_order_management': 'إدارة أوامر العمل الأساسية',
  'pricing.sh_feature_asset_inventory_tracking': 'تتبع الأصول والمخزون',
  'pricing.sh_feature_local_data_storage': 'تخزين البيانات المحلي',
  'pricing.sh_plan_professional_name': 'احترافي',
  'pricing.sh_plan_professional_description':
    'مثالي لزراعة النباتات التي تتطلب قوائم مراجعة متقدمة، وسير عمل، وتكامل أعمق للنظام.',
  'pricing.sh_feature_everything_in_basic_plus':
    'كل شيء في النسخة الأساسية بالإضافة إلى:',
  'pricing.sh_feature_unlimited_assets_checklists':
    'أصول/قوائم مراجعة غير محدودة',
  'pricing.sh_feature_nfc_barcode_scanning':
    'تقنية الاتصال قريب المدى ومسح الباركود',
  'pricing.sh_feature_email_support': 'دعم عبر البريد الإلكتروني',
  'pricing.sh_plan_business_name': 'عمل',
  'pricing.sh_plan_business_description':
    'عمليات واسعة النطاق تتطلب إدارة متعددة النسخ، وعلامات تجارية مخصصة، وأمانًا من الدرجة الأولى.',
  'pricing.sh_feature_everything_in_professional_plus':
    'كل شيء في النسخة الاحترافية بالإضافة إلى:',
  'pricing.sh_feature_multi_instance_management': 'إدارة النسخ المتعددة',
  'pricing.sh_feature_custom_user_roles': 'أدوار المستخدم المخصصة',
  'pricing.sh_feature_priority_implementation_support':
    'دعم التنفيذ ذو الأولوية',
  'pricing.faq_free_users_q':
    'ما هي أنواع المستخدمين الذين يُعتبرون مستخدمين مجانيين؟',
  'pricing.faq_free_users_a1':
    'هناك ثلاثة أنواع من المستخدمين لا تتطلب ترخيصًا مدفوعًا:',
  'pricing.faq_view_only_users_title': 'عرض المستخدمين فقط',
  'pricing.faq_view_only_users_description':
    'هؤلاء المستخدمون هم عادةً مشرفون يسجلون الدخول بشكل غير متكرر للاطلاع على لمحة سريعة عن أنشطة الصيانة. كما يمكنهم تقديم طلبات العمل وإعداد التقارير.',
  'pricing.faq_requester_users_title': 'المستخدمون مقدمو الطلبات',
  'pricing.faq_requester_users_description':
    'يقتصر دور هؤلاء المستخدمين على تقديم طلبات العمل والاطلاع على حالة تلك الطلبات. ولا يمكنهم رؤية أوامر العمل أو الأصول أو قطع الغيار أو أي بيانات أخرى مخزنة في نظام إدارة الصيانة المحوسب.',
  'pricing.faq_third_party_users_title': 'مستخدمو الطرف الثالث',
  'pricing.faq_third_party_users_description':
    'هؤلاء المستخدمون عادةً ما يكونون موردين ومقاولين. لا يمكنهم تسجيل الدخول إلى النظام فعلياً. يمكنهم فقط إرسال تحديثات لأمر عمل محدد تم وضع علامة عليهم فيه عبر رابط عام.',
  'pricing.faq_paid_users_q':
    'ما هي أنواع المستخدمين الذين يُعتبرون مستخدمين مدفوعين؟',
  'pricing.faq_paid_users_a1':
    'هناك ثلاثة أنواع من المستخدمين تتطلب ترخيصًا مدفوعًا:',
  'pricing.faq_admin_users_title': 'المستخدمون الإداريون',
  'pricing.faq_admin_users_description':
    'يتمتع هؤلاء المستخدمون بصلاحية إضافة مستخدمين آخرين إلى الحساب، وقبول طلبات العمل أو رفضها، وتعديل تفاصيل أوامر العمل. وهم المستخدمون الذين يتحكمون بالحساب. يمكنك تعيين أكثر من مسؤول لكل حساب.',
  'pricing.faq_technical_users_title': 'المستخدمون التقنيون',
  'pricing.faq_technical_users_description':
    'هؤلاء المستخدمون هم عادةً فنيون يقومون بإغلاق أوامر العمل ميدانياً. بإمكانهم تعديل أوامر العمل التي أنشأوها، ولكن ليس أوامر العمل الأخرى. كما يمكنهم إضافة صور وتحديثات الحالة إلى أوامر العمل، وإنشاء أوامر عمل جديدة.',
  'pricing.faq_limited_technical_users_title': 'مستخدمون تقنيون محدودون',
  'pricing.faq_limited_technical_users_description':
    'يتمتع هؤلاء المستخدمون بنفس صلاحيات المستخدم التقني، باستثناء أنهم لا يستطيعون رؤية سوى أوامر العمل المخصصة لهم، وليس أوامر العمل الخاصة بالمستخدمين التقنيين الآخرين في الحساب.',
  'pricing.faq_change_plans_q': 'هل يمكنني تغيير الخطط لاحقاً؟',
  'pricing.faq_change_plans_a':
    'نعم، يمكنك ترقية أو تخفيض خطتك في أي وقت. تُصبح التغييرات سارية المفعول مع بداية دورة الفوترة التالية.',
  'pricing.faq_free_trial_q': 'هل هناك فترة تجريبية مجانية؟',
  'pricing.faq_free_trial_a':
    'نعم، نحن نقدم فترة تجريبية مجانية لمدة 15 يومًا لخطة الأعمال حتى تتمكن من تجربة جميع الميزات قبل اتخاذ القرار.',
  'pricing.faq_non_profit_discounts_q':
    'هل تقدمون خصومات للمنظمات غير الربحية؟',
  'pricing.faq_non_profit_discounts_a':
    'نعم، نقدم أسعاراً خاصة للمنظمات غير الربحية. يرجى التواصل مع فريق المبيعات لدينا لمزيد من المعلومات.',
  'pricing.faq_payment_methods_q': 'ما هي طرق الدفع التي تقبلونها؟',
  'pricing.faq_payment_methods_a':
    'نقبل جميع بطاقات الائتمان الرئيسية، والتحويلات البنكية، وباي بال. بالنسبة لخطط المؤسسات، يمكننا أيضاً ترتيب إصدار الفواتير.',
  'pricing.faq_cancel_subscription_q': 'هل يمكنني إلغاء اشتراكي؟',
  'pricing.faq_cancel_subscription_a':
    'نعم، يمكنك إلغاء اشتراكك في أي وقت. وسيظل بإمكانك الوصول إلى الخدمة حتى نهاية فترة فوترتك الحالية.',
  'pricing.faq_data_secure_q': 'هل بياناتي آمنة؟',
  'pricing.faq_data_secure_a':
    'نعم، نحن نأخذ أمن البيانات على محمل الجد. يتم تشفير جميع البيانات أثناء نقلها وتخزينها، ونجري عمليات تدقيق أمنية منتظمة.',
  'pricing.faq_title': 'الأسئلة الشائعة',
  'pricing.annually_save_two_months': 'سنوياً (توفير شهرين)',
  'pricing.most_popular': 'الأكثر شعبية',
  'pricing.get_your_license': 'احصل على رخصتك',
  get_started: 'ابدأ الآن',
  workflow_automation: 'أتمتة سير العمل',
  push_notifications: 'الإشعارات الفورية',
  cloud: 'سحاب',
  self_hosted: 'الاستضافة الذاتية',
  full: 'ممتلىء',
  pricing: 'التسعير',
  industries: 'الصناعات',
  work_order_management: 'إدارة أوامر العمل',
  inventory_management: 'إدارة المخزون',
  analytics_and_reporting: 'التحليلات والتقارير',
  manufacturing: 'التصنيع',
  facility_management: 'إدارة المرافق',
  food_and_beverage: 'الأغذية والمشروبات',
  healthcare: 'الرعاية الصحية',
  energy_and_utilities: 'الطاقة والمرافق',
  education: 'التعليم',
  hospitality: 'الضيافة',
  construction: 'البناء والتشييد',
  installation_docs: 'وثائق التثبيت',
  upload_telemetry: 'Upload Telemetry',
  telemetry_dialog_title: 'Upload Telemetry File',
  telemetry_dialog_subtitle:
    'Select an Excel file with Placa, Kilometraje Final and Horómetro Final columns.',
  telemetry_uploading: 'Uploading…',
  telemetry_upload_success: 'Telemetry uploaded successfully',
  telemetry_upload_failure: 'Telemetry upload failed',
  telemetry_no_rows: 'No data rows found. Check that the sheet has a "Placa" header.',
  telemetry_result: 'Upload summary',
  telemetry_assets_updated: 'Assets updated',
  telemetry_readings_created: 'Readings created',
  telemetry_meters_created: 'Meters auto-created',
  telemetry_not_found: 'Unmatched plates',
  telemetry_ambiguous: 'Ambiguous plates (skipped)'
};

export default locale;
